// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"5Tqlz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _concept = require("./screens/Concept");
const app = document.getElementById("app");
const root = (0, _clientDefault.default).createRoot(app);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _concept.Concept), {}));

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom/client":"5ccwt","./screens/Concept":"2f7eS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaGEj":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"6uln9"}],"6uln9":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.2.0";

},{}],"5ccwt":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"b8T3j"}],"b8T3j":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var Mg = Uf(null), Ng = null, Og = null, Pg = null;
function Qg() {
    Pg = Og = Ng = null;
}
function Rg(a) {
    var b = Mg.current;
    E(Mg);
    a._currentValue = b;
}
function Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function Tg(a, b) {
    Ng = a;
    Pg = Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (Ug = !0), a.firstContext = null);
}
function Vg(a) {
    var b = a._currentValue;
    if (Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Og) {
            if (null === Ng) throw Error(p(308));
            Og = a;
            Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Og = Og.next = a;
    }
    return b;
}
var Wg = null;
function Xg(a) {
    null === Wg ? Wg = [
        a
    ] : Wg.push(a);
}
function Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return Zg(a, d);
}
function Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $g = !1;
function ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return Zg(a, c);
}
function eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function gh(a, b, c, d) {
    var e = a.updateQueue;
    $g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            $g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var jh = (new aa.Component).refs;
function kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = L(), d = lh(a), e = ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = dh(a, e, d);
        null !== b && (mh(b, a, d, c), eh(b, a, d));
    }
};
function oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function ph(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = Vg(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && nh.enqueueReplaceState(b, b.state, null);
}
function rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = jh;
    ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = Vg(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && nh.enqueueReplaceState(e, e.state, null), gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function uh(a) {
    var b = a._init;
    return b(a._payload);
}
function vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && uh(f) === b.type)) return d = e(b, c.props), d.ref = sh(a, b, c), d.return = a, d;
        d = yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = yh(b.type, b.key, b.props, null, a.mode, c), c.ref = sh(a, null, b), c.return = a, c;
                case wa:
                    return b = zh(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Ah(b, a.mode, c, null), b.return = a, b;
            th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = yh(f.type, f.key, f.props, null, a.mode, h), h.ref = sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Bh = vh(!0), Ch = vh(!1), Dh = {}, Eh = Uf(Dh), Fh = Uf(Dh), Gh = Uf(Dh);
function Hh(a) {
    if (a === Dh) throw Error(p(174));
    return a;
}
function Ih(a, b) {
    G(Gh, b);
    G(Fh, a);
    G(Eh, Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(Eh);
    G(Eh, b);
}
function Jh() {
    E(Eh);
    E(Fh);
    E(Gh);
}
function Kh(a) {
    Hh(Gh.current);
    var b = Hh(Eh.current);
    var c = lb(b, a.type);
    b !== c && (G(Fh, a), G(Eh, c));
}
function Lh(a) {
    Fh.current === a && (E(Eh), E(Fh));
}
var M = Uf(0);
function Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Nh = [];
function Oh() {
    for(var a = 0; a < Nh.length; a++)Nh[a]._workInProgressVersionPrimary = null;
    Nh.length = 0;
}
var Ph = ua.ReactCurrentDispatcher, Qh = ua.ReactCurrentBatchConfig, Rh = 0, N = null, O = null, P = null, Sh = !1, Th = !1, Uh = 0, Vh = 0;
function Q() {
    throw Error(p(321));
}
function Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Xh(a, b, c, d, e, f) {
    Rh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Ph.current = null === a || null === a.memoizedState ? Yh : Zh;
    a = c(d, e);
    if (Th) {
        f = 0;
        do {
            Th = !1;
            Uh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            Ph.current = $h;
            a = c(d, e);
        }while (Th);
    }
    Ph.current = ai;
    b = null !== O && null !== O.next;
    Rh = 0;
    P = O = N = null;
    Sh = !1;
    if (b) throw Error(p(300));
    return a;
}
function bi() {
    var a = 0 !== Uh;
    Uh = 0;
    return a;
}
function ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function di() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(p(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function fi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                N.lanes |= m;
                hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, N.lanes |= f, hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function gi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function hi() {}
function ii(a, b) {
    var c = N, d = di(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, Ug = !0);
    d = d.queue;
    ji(ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== P && P.memoizedState.tag & 1) {
        c.flags |= 2048;
        li(9, mi.bind(null, c, d, e, b), void 0, null);
        if (null === R) throw Error(p(349));
        0 !== (Rh & 30) || ni(c, b, e);
    }
    return e;
}
function ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    oi(b) && pi(a);
}
function ki(a, b, c) {
    return c(function() {
        oi(b) && pi(a);
    });
}
function oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function pi(a) {
    var b = Zg(a, 1);
    null !== b && mh(b, a, 1, -1);
}
function qi(a) {
    var b = ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ri.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function si() {
    return di().memoizedState;
}
function ti(a, b, c, d) {
    var e = ci();
    N.flags |= a;
    e.memoizedState = li(1 | b, c, void 0, void 0 === d ? null : d);
}
function ui(a, b, c, d) {
    var e = di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && Wh(d, g.deps)) {
            e.memoizedState = li(b, c, f, d);
            return;
        }
    }
    N.flags |= a;
    e.memoizedState = li(1 | b, c, f, d);
}
function vi(a, b) {
    return ti(8390656, 8, a, b);
}
function ji(a, b) {
    return ui(2048, 8, a, b);
}
function wi(a, b) {
    return ui(4, 2, a, b);
}
function xi(a, b) {
    return ui(4, 4, a, b);
}
function yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return ui(4, 4, yi.bind(null, b, a), c);
}
function Ai() {}
function Bi(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ci(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Di(a, b, c) {
    if (0 === (Rh & 21)) return a.baseState && (a.baseState = !1, Ug = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), N.lanes |= c, hh |= c, a.baseState = !0);
    return b;
}
function Ei(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Qh.transition;
    Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Qh.transition = d;
    }
}
function Fi() {
    return di().memoizedState;
}
function Gi(a, b, c) {
    var d = lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, c);
    else if (c = Yg(a, b, c, d), null !== c) {
        var e = L();
        mh(c, a, d, e);
        Ji(c, b, d);
    }
}
function ri(a, b, c) {
    var d = lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = Yg(a, b, e, d);
        null !== c && (e = L(), mh(c, a, d, e), Ji(c, b, d));
    }
}
function Hi(a) {
    var b = a.alternate;
    return a === N || null !== b && b === N;
}
function Ii(a, b) {
    Th = Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var ai = {
    readContext: Vg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useInsertionEffect: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useDeferredValue: Q,
    useTransition: Q,
    useMutableSource: Q,
    useSyncExternalStore: Q,
    useId: Q,
    unstable_isNewReconciler: !1
}, Yh = {
    readContext: Vg,
    useCallback: function(a, b) {
        ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: Vg,
    useEffect: vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ti(4194308, 4, yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = Gi.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: qi,
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        return ci().memoizedState = a;
    },
    useTransition: function() {
        var a = qi(!1), b = a[0];
        a = Ei.bind(null, a[1]);
        ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = N, e = ci();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === R) throw Error(p(349));
            0 !== (Rh & 30) || ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        vi(ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        li(9, mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = ci(), b = R.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Zh = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: fi,
    useRef: si,
    useState: function() {
        return fi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = fi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
}, $h = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: gi,
    useRef: si,
    useState: function() {
        return gi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return null === O ? b.memoizedState = a : Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = gi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
};
function Ki(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Ni = "function" === typeof WeakMap ? WeakMap : Map;
function Oi(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Pi || (Pi = !0, Qi = d);
        Mi(a, b);
    };
    return c;
}
function Ri(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Mi(a, b);
        "function" !== typeof d && (null === Si ? Si = new Set([
            this
        ]) : Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ui.bind(null, a, b, c), b.then(a, a));
}
function Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = ch(-1, 1), b.tag = 2, dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Xi = ua.ReactCurrentOwner, Ug = !1;
function Yi(a, b, c, d) {
    b.child = null === a ? Ch(b, null, c, d) : Bh(b, a.child, c, d);
}
function Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    Tg(b, e);
    d = Xh(a, b, c, d, f, e);
    c = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Yi(a, b, d, e);
    return b.child;
}
function aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, cj(a, b, f, d, e);
        a = yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return $i(a, b, e);
    }
    b.flags |= 1;
    a = wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (Ug = !0);
            else return b.lanes = a.lanes, $i(a, b, e);
        }
    }
    return dj(a, b, c, d, e);
}
function ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(fj, gj), gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(fj, gj), gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(fj, gj);
            gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(fj, gj), gj |= d;
    Yi(a, b, e, c);
    return b.child;
}
function hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function dj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    Tg(b, e);
    c = Xh(a, b, c, d, f, e);
    d = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Yi(a, b, c, e);
    return b.child;
}
function ij(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    Tg(b, e);
    if (null === b.stateNode) jj(a, b), ph(b, c, d), rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = Vg(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && qh(b, g, d, l);
        $g = !1;
        var r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || $g ? ("function" === typeof m && (kh(b, c, m, d), k = b.memoizedState), (h = $g || oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = Vg(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && qh(b, g, d, k);
        $g = !1;
        r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || $g ? ("function" === typeof y && (kh(b, c, y, d), n = b.memoizedState), (l = $g || oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return kj(a, b, c, d, f, e);
}
function kj(a, b, c, d, e, f) {
    hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), $i(a, b, f);
    d = b.stateNode;
    Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Bh(b, a.child, null, f), b.child = Bh(b, null, h, f)) : Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function lj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    Ih(a, b.containerInfo);
}
function mj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Yi(a, b, c, d);
    return b.child;
}
var nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function pj(a, b, c) {
    var d = b.pendingProps, e = M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(M, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = qj(g, d, 0, null), a = Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = oj(c), b.memoizedState = nj, a) : rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = wh(h, f) : (f = Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function rj(a, b) {
    b = qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function tj(a, b, c, d) {
    null !== d && Jg(d);
    Bh(b, a.child, null, c);
    a = rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Li(Error(p(422))), tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Bh(b, a.child, null, g);
        b.child.memoizedState = oj(g);
        b.memoizedState = nj;
        return f;
    }
    if (0 === (b.mode & 1)) return tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Li(f, d, void 0);
        return tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (Ug || h) {
        d = R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, Zg(a, e), mh(d, a, e, -1));
        }
        uj();
        d = Li(Error(p(421)));
        return tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    Sg(a.return, b, c);
}
function xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Yi(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && wj(a, c, b);
            else if (19 === a.tag) wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            xj(b, !0, c, null, f);
            break;
        case "together":
            xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function zj(a, b, c) {
    switch(b.tag){
        case 3:
            lj(b);
            Ig();
            break;
        case 5:
            Kh(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(M, M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return pj(a, b, c);
                G(M, M.current & 1);
                a = $i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(M, M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(M, M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, ej(a, b, c);
    }
    return $i(a, b, c);
}
var Aj, Bj, Cj, Dj;
Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Bj = function() {};
Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        Hh(Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Ej(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Fj(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            Jh();
            E(Wf);
            E(H);
            Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Gj(zg), zg = null));
            Bj(a, b);
            S(b);
            return null;
        case 5:
            Lh(b);
            var e = Hh(Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = Hh(Gh.current);
                Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Gj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (M.current & 1) ? 0 === T && (T = 3) : uj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return Jh(), Bj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return Rg(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(M);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Ej(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(M, M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Hj && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Hj && 1073741824 !== c && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = M.current, G(M, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (gj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Jj(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return Jh(), E(Wf), E(H), Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Lh(b), null;
        case 13:
            E(M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(M), null;
        case 4:
            return Jh(), null;
        case 10:
            return Rg(b.type._context), null;
        case 22:
        case 23:
            return Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Kj = !1, U = !1, Lj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Oj = !1;
function Pj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Oj;
    Oj = !1;
    return n;
}
function Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
function Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Xj(a, b, c), a = a.sibling; null !== a;)Xj(a, b, c), a = a.sibling;
}
var X = null, Yj = !1;
function Zj(a, b, c) {
    for(c = c.child; null !== c;)ak(a, b, c), c = c.sibling;
}
function ak(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Mj(c, b);
        case 6:
            var d = X, e = Yj;
            X = null;
            Zj(a, b, c);
            X = d;
            Yj = e;
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Yj;
            X = c.stateNode.containerInfo;
            Yj = !0;
            Zj(a, b, c);
            X = d;
            Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Nj(c, b, g) : 0 !== (f & 4) && Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Zj(a, b, c);
            break;
        case 1:
            if (!U && (Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Zj(a, b, c);
            break;
        case 21:
            Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Zj(a, b, c), U = d) : Zj(a, b, c);
            break;
        default:
            Zj(a, b, c);
    }
}
function bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Lj);
        b.forEach(function(b) {
            var d = ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Yj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            ak(f, g, e);
            X = null;
            Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)ek(b, a), b = b.sibling;
}
function ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            dk(b, a);
            fk(a);
            if (d & 4) {
                try {
                    Qj(3, a, a.return), Rj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Qj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            break;
        case 5:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            dk(b, a);
            fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            dk(b, a);
            fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            dk(b, a);
            fk(a);
            break;
        case 13:
            dk(b, a);
            fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (gk = B()));
            d & 4 && bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, dk(b, a), U = l) : dk(b, a);
            fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Qj(4, r, r.return);
                                break;
                            case 1:
                                Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            dk(b, a);
            fk(a);
            d & 4 && bk(a);
            break;
        case 21:
            break;
        default:
            dk(b, a), fk(a);
    }
}
function fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Vj(a);
                    Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Vj(a);
                    Wj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function ik(a, b, c) {
    V = a;
    jk(a, b, c);
}
function jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Kj;
                var l = U;
                Kj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? kk(e) : null !== k ? (k.return = g, V = k) : kk(e);
                for(; null !== f;)V = f, jk(f, b, c), f = f.sibling;
                V = e;
                Kj = h;
                U = l;
            }
            lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : lk(a, b, c);
    }
}
function lk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Sj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function hk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Rj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var mk = Math.ceil, nk = ua.ReactCurrentDispatcher, ok = ua.ReactCurrentOwner, pk = ua.ReactCurrentBatchConfig, K = 0, R = null, Y = null, Z = 0, gj = 0, fj = Uf(0), T = 0, qk = null, hh = 0, rk = 0, sk = 0, tk = null, uk = null, gk = 0, Hj = Infinity, vk = null, Pi = !1, Qi = null, Si = null, wk = !1, xk = null, yk = 0, zk = 0, Ak = null, Bk = -1, Ck = 0;
function L() {
    return 0 !== (K & 6) ? B() : -1 !== Bk ? Bk : Bk = B();
}
function lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Ck && (Ck = yc()), Ck;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function mh(a, b, c, d) {
    if (50 < zk) throw zk = 0, Ak = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== R) a === R && (0 === (K & 2) && (rk |= c), 4 === T && Dk(a, Z)), Ek(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Hj = B() + 500, fg && jg());
}
function Ek(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Fk.bind(null, a)) : hg(Fk.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Gk(c, Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Hk(a, b) {
    Bk = -1;
    Ck = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Ik() && a.callbackNode !== c) return null;
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Jk(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Kk();
        if (R !== a || Z !== b) vk = null, Hj = B() + 500, Lk(a, b);
        for(;;)try {
            Mk();
            break;
        } catch (h) {
            Nk(a, h);
        }
        Qg();
        nk.current = f;
        K = e;
        null !== Y ? b = 0 : (R = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Ok(a, e)));
        if (1 === b) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
        if (6 === b) Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Pk(e) && (b = Jk(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Ok(a, f))), 1 === b)) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Qk(a, uk, vk);
                    break;
                case 3:
                    Dk(a, d);
                    if ((d & 130023424) === d && (b = gk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), b);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 4:
                    Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), d);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 5:
                    Qk(a, uk, vk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Ek(a, B());
    return a.callbackNode === c ? Hk.bind(null, a) : null;
}
function Ok(a, b) {
    var c = tk;
    a.current.memoizedState.isDehydrated && (Lk(a, b).flags |= 256);
    a = Jk(a, b);
    2 !== a && (b = uk, uk = c, null !== b && Gj(b));
    return a;
}
function Gj(a) {
    null === uk ? uk = a : uk.push.apply(uk, a);
}
function Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Dk(a, b) {
    b &= ~sk;
    b &= ~rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Fk(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Ik();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Ek(a, B()), null;
    var c = Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Ok(a, d));
    }
    if (1 === c) throw c = qk, Lk(a, 0), Dk(a, b), Ek(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Qk(a, uk, vk);
    Ek(a, B());
    return null;
}
function Rk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Hj = B() + 500, fg && jg());
    }
}
function Sk(a) {
    null !== xk && 0 === xk.tag && 0 === (K & 6) && Ik();
    var b = K;
    K |= 1;
    var c = pk.transition, d = C;
    try {
        if (pk.transition = null, C = 1, a) return a();
    } finally{
        C = d, pk.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Ij() {
    gj = fj.current;
    E(fj);
}
function Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                Jh();
                E(Wf);
                E(H);
                Oh();
                break;
            case 5:
                Lh(d);
                break;
            case 4:
                Jh();
                break;
            case 13:
                E(M);
                break;
            case 19:
                E(M);
                break;
            case 10:
                Rg(d.type._context);
                break;
            case 22:
            case 23:
                Ij();
        }
        c = c.return;
    }
    R = a;
    Y = a = wh(a.current, null);
    Z = gj = b;
    T = 0;
    qk = null;
    sk = rk = hh = 0;
    uk = tk = null;
    if (null !== Wg) {
        for(b = 0; b < Wg.length; b++)if (c = Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        Wg = null;
    }
    return a;
}
function Nk(a, b) {
    do {
        var c = Y;
        try {
            Qg();
            Ph.current = ai;
            if (Sh) {
                for(var d = N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Sh = !1;
            }
            Rh = 0;
            P = O = N = null;
            Th = !1;
            Uh = 0;
            ok.current = null;
            if (null === c || null === c.return) {
                T = 1;
                qk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Wi(y, g, h, f, b);
                        y.mode & 1 && Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Ti(f, l, b);
                            uj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Wi(J, g, h, f, b);
                        Jg(Ki(k, h));
                        break a;
                    }
                }
                f = k = Ki(k, h);
                4 !== T && (T = 2);
                null === tk ? tk = [
                    f
                ] : tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Oi(f, k, b);
                            fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Si || !Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Ri(f, h, b);
                                fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Tk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Kk() {
    var a = nk.current;
    nk.current = ai;
    return null === a ? ai : a;
}
function uj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === R || 0 === (hh & 268435455) && 0 === (rk & 268435455) || Dk(R, Z);
}
function Jk(a, b) {
    var c = K;
    K |= 2;
    var d = Kk();
    if (R !== a || Z !== b) vk = null, Lk(a, b);
    for(;;)try {
        Uk();
        break;
    } catch (e) {
        Nk(a, e);
    }
    Qg();
    K = c;
    nk.current = d;
    if (null !== Y) throw Error(p(261));
    R = null;
    Z = 0;
    return T;
}
function Uk() {
    for(; null !== Y;)Vk(Y);
}
function Mk() {
    for(; null !== Y && !cc();)Vk(Y);
}
function Vk(a) {
    var b = Wk(a.alternate, a, gj);
    a.memoizedProps = a.pendingProps;
    null === b ? Tk(a) : Y = b;
    ok.current = null;
}
function Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Fj(c, b, gj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Qk(a, b, c) {
    var d = C, e = pk.transition;
    try {
        pk.transition = null, C = 1, Xk(a, b, c, d);
    } finally{
        pk.transition = e, C = d;
    }
    return null;
}
function Xk(a, b, c, d) {
    do Ik();
    while (null !== xk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === R && (Y = R = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || wk || (wk = !0, Gk(hc, function() {
        Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = pk.transition;
        pk.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        ok.current = null;
        Pj(a, c);
        ek(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        ik(c, a, e);
        dc();
        K = h;
        C = g;
        pk.transition = f;
    } else a.current = c;
    wk && (wk = !1, xk = a, yk = e);
    f = a.pendingLanes;
    0 === f && (Si = null);
    mc(c.stateNode, d);
    Ek(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Pi) throw Pi = !1, a = Qi, Qi = null, a;
    0 !== (yk & 1) && 0 !== a.tag && Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === Ak ? zk++ : (zk = 0, Ak = a) : zk = 0;
    jg();
    return null;
}
function Ik() {
    if (null !== xk) {
        var a = Dc(yk), b = pk.transition, c = C;
        try {
            pk.transition = null;
            C = 16 > a ? 16 : a;
            if (null === xk) var d = !1;
            else {
                a = xk;
                xk = null;
                yk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Tj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Rj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, pk.transition = b;
        }
    }
    return !1;
}
function Yk(a, b, c) {
    b = Ki(c, b);
    b = Oi(a, b, 1);
    a = dh(a, b, 1);
    b = L();
    null !== a && (Ac(a, 1, b), Ek(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Si || !Si.has(d))) {
                a = Ki(c, a);
                a = Ri(b, a, 1);
                b = dh(b, a, 1);
                a = L();
                null !== b && (Ac(b, 1, a), Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = L();
    a.pingedLanes |= a.suspendedLanes & c;
    R === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - gk ? Lk(a, 0) : sk |= c);
    Ek(a, b);
}
function Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = L();
    a = Zg(a, b);
    null !== a && (Ac(a, b, c), Ek(a, c));
}
function vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Zk(a, c);
}
function ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Zk(a, c);
}
var Wk;
Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return Ug = !1, zj(a, b, c);
            Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else Ug = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            jj(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            Tg(b, c);
            e = Xh(null, b, d, a, e, c);
            var f = bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, ah(b), e.updater = nh, b.stateNode = e, e._reactInternals = b, rh(b, d, a, c), b = kj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $k(d);
                a = Lg(d, a);
                switch(e){
                    case 0:
                        b = dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = aj(null, b, d, Lg(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), ij(a, b, d, e, c);
        case 3:
            a: {
                lj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                bh(a, b);
                gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ki(Error(p(423)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ki(Error(p(424)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = $i(a, b, c);
                        break a;
                    }
                    Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Kh(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), hj(a, b), Yi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return pj(a, b, c);
        case 4:
            return Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Bh(b, null, d, c) : Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), Zi(a, b, d, e, c);
        case 7:
            return Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = $i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, Tg(b, c), e = Vg(e), d = d(e), b.flags |= 1, Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Lg(d, b.pendingProps), e = Lg(d.type, e), aj(a, b, d, e, c);
        case 15:
            return cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), jj(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, Tg(b, c), ph(b, d, e), rh(b, d, e, c), kj(null, b, d, !0, a, c);
        case 19:
            return yj(a, b, c);
        case 22:
            return ej(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Gk(a, b) {
    return ac(a, b);
}
function al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new al(a, b, c, d);
}
function bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $k(a) {
    if ("function" === typeof a) return bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function wh(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Ah(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Ah(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function qj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function xh(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function zh(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function cl(a, b, c, d, e, f, g, h, k) {
    a = new bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    ah(f);
    return a;
}
function dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function el(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function fl(a, b, c, d, e, f, g, h, k) {
    a = cl(c, d, !0, a, e, f, g, h, k);
    a.context = el(null);
    c = a.current;
    d = L();
    e = lh(c);
    f = ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    dh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Ek(a, d);
    return a;
}
function gl(a, b, c, d) {
    var e = b.current, f = L(), g = lh(e);
    c = el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = dh(e, b, g);
    null !== a && (mh(a, e, g, f), eh(a, e, g));
    return g;
}
function hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function jl(a, b) {
    il(a, b);
    (a = a.alternate) && il(a, b);
}
function kl() {
    return null;
}
var ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ml(a) {
    this._internalRoot = a;
}
nl.prototype.render = ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    gl(a, b, null, null);
};
nl.prototype.unmount = ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Sk(function() {
            gl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function nl(a) {
    this._internalRoot = a;
}
nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function ql() {}
function rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = hl(g);
                f.call(a);
            };
        }
        var g = fl(b, d, a, 0, null, !1, !1, "", ql);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = hl(k);
            h.call(a);
        };
    }
    var k = cl(a, 0, !1, null, null, !1, !1, "", ql);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Sk(function() {
        gl(b, k, c, d);
    });
    return k;
}
function sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = hl(g);
                h.call(a);
            };
        }
        gl(b, g, a, e);
    } else g = rl(c, b, a, e, d);
    return hl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Ek(b, B()), 0 === (K & 6) && (Hj = B() + 500, jg()));
            }
            break;
        case 13:
            Sk(function() {
                var b = Zg(a, 1);
                if (null !== b) {
                    var c = L();
                    mh(b, a, 1, c);
                }
            }), jl(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = Zg(a, 134217728);
        if (null !== b) {
            var c = L();
            mh(b, a, 134217728, c);
        }
        jl(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = lh(a), c = Zg(a, b);
        if (null !== c) {
            var d = L();
            mh(c, a, b, d);
        }
        jl(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Rk;
Hb = Sk;
var tl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Rk
    ]
}, ul = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var vl = {
    bundleType: ul.bundleType,
    version: ul.version,
    rendererPackageName: ul.rendererPackageName,
    rendererConfig: ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: ul.findFiberByHostInstance || kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!wl.isDisabled && wl.supportsFiber) try {
        kc = wl.inject(vl), lc = wl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!ol(b)) throw Error(p(200));
    return dl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!ol(a)) throw Error(p(299));
    var c = !1, d = "", e = ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = cl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ml(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Sk(a);
};
exports.hydrate = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!ol(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new nl(b);
};
exports.render = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!pl(a)) throw Error(p(40));
    return a._reactRootContainer ? (Sk(function() {
        sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Rk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!pl(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return sl(a, b, c, !1, d);
};
exports.version = "18.2.0-next-9e3b772b8-20220608";

},{"5393afc8c463ef07":"6uln9","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"2f7eS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Concept", ()=>(0, _concept.Concept));
var _concept = require("./Concept");

},{"./Concept":"eoUp3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eoUp3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Concept", ()=>Concept);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _gallereact = require("gallereact");
var _gallereactDefault = parcelHelpers.interopDefault(_gallereact);
var _react1 = require("@headlessui/react");
var _fileSaver = require("file-saver");
var _styleCss = require("./style.css");
const IMAGES = [
    "/img/gallery1.jpeg",
    "/img/gallery2.jpeg",
    "/img/gallery3.jpeg",
    "/img/gallery4.jpeg",
    "/img/gallery5.jpeg",
    "/img/gallery6.jpeg",
    "/img/gallery7.jpeg",
    "/img/gallery8.jpeg",
    "/img/gallery9.jpeg",
    "/img/gallery10.jpeg",
    "/img/gallery11.jpg",
    "/img/gallery12.jpg",
    "/img/gallery13.jpg",
    "/img/gallery14.jpg",
    "/img/gallery15.jpg",
    "/img/gallery16.jpg",
    "/img/gallery17.jpg"
];
const NAVER_MAP_URL = "http://app.map.naver.com/launchApp/?version=11&menu=navigation&elat=37.5292711&elng=126.9248993&etitle=%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C%20%EC%98%81%EB%93%B1%ED%8F%AC%EA%B5%AC%20%EC%97%AC%EC%9D%98%EA%B3%B5%EC%9B%90%EB%A1%9C%20101%20C.C.M.M%EB%B9%8C%EB%94%A9";
const KAKAO_MAP_URL = "https://m.map.kakao.com/scheme/route?sp=&sn=&ep=37.529272050075036%2C126.92489726390208&en=%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C+%EC%98%81%EB%93%B1%ED%8F%AC%EA%B5%AC+%EC%97%AC%EC%9D%98%EA%B3%B5%EC%9B%90%EB%A1%9C+101+C.C.M.M%EB%B9%8C%EB%94%A9&by=car";
const TMAP_MAP_URL = "https://www.tmap.co.kr/tmap2/mobile/route.jsp?appKey=oHGRBx21y07ZDotWXUgPR4Asg6pP8SE26ArnqEU7&lat=37.5292711&lon=126.9248993&name=%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C+%EC%98%81%EB%93%B1%ED%8F%AC%EA%B5%AC+%EC%97%AC%EC%9D%98%EA%B3%B5%EC%9B%90%EB%A1%9C+101+C.C.M.M%EB%B9%8C%EB%94%A9";
const ACCOUNTS1 = [
    [
        `(신랑) 이정영ㆍ`,
        `기업 555-000074-01-011`
    ],
    [
        `(부) 이용식ㆍ`,
        `농협 2170-2652-1080-11`
    ],
    [
        `(모) 김삼례ㆍ`,
        `농협 2170-3252-0133-29`
    ]
];
const ACCOUNTS2 = [
    [
        `(신부) 유예진ㆍ`,
        `카카오 3333-05-2840713`
    ],
    [
        `(부) 유훈ㆍ`,
        `국민 448601-01-098120`
    ],
    [
        `(모) 김미영ㆍ`,
        `국민 209702-04-171990`
    ]
];
const CONTACTS1 = [
    [
        `(신랑) 이정영ㆍ`,
        `010-7120-6334`
    ],
    [
        `(부) 이용식ㆍ`,
        `010-8904-6334`
    ],
    [
        `(모) 김삼례ㆍ`,
        `010-7768-6334`
    ]
];
const CONTACTS2 = [
    [
        `(신부) 유예진ㆍ`,
        `010-8109-0643`
    ],
    [
        `(부) 유훈ㆍ`,
        `010-3254-0621`
    ],
    [
        `(모) 김미영ㆍ`,
        `010-4269-4345`
    ]
];
const shuffle = (arr)=>arr.sort(()=>Math.random() - 0.5);
const copyClipBoard = async (text)=>{
    try {
        await navigator.clipboard.writeText(text);
        alert("복사가 완료됐습니다.");
    } catch (error) {
        alert("복사 실패!");
    }
};
const Concept = ()=>{
    const [images] = (0, _reactDefault.default).useState(IMAGES);
    const [isAccount1Open, setIsAccount1Open] = (0, _reactDefault.default).useState(false);
    const [isAccount2Open, setIsAccount2Open] = (0, _reactDefault.default).useState(false);
    const [isContact1Open, setIsContact1Open] = (0, _reactDefault.default).useState(false);
    const [isContact2Open, setIsContact2Open] = (0, _reactDefault.default).useState(false);
    (0, _reactDefault.default).useEffect(()=>{
        const container = document.getElementById("map");
        const options = {
            center: new window.kakao.maps.LatLng(37.5292711, 126.9248993),
            level: 3,
            draggable: false
        };
        const map = new window.kakao.maps.Map(container, options);
        const zoomControl = new window.kakao.maps.ZoomControl();
        map.addControl(zoomControl, window.kakao.maps.ControlPosition.RIGHT);
        const markerPosition = new kakao.maps.LatLng(37.5292711, 126.9248993);
        const marker = new kakao.maps.Marker({
            position: markerPosition
        });
        marker.setMap(map);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "concept",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "div",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-wrapper",
                                    children: "2023년 9월 16일 토요일 오후 5시"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title",
                                    children: "서울 여의도 루나미엘레 그랜드볼룸"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title-2",
                                    children: ""
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title-3",
                                    children: "이정영\xa0\xa0&\xa0\xa0유예진"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "images",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "talkmedia-i",
                            alt: "Talkmedia i",
                            src: "/img/talkmedia-i-j6fb34-1.png"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "text",
                        children: [
                            "서로 다른 두 사람이 만나 함께하여 결혼을 약속합니다 ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            "저희가 부부의 연으로 길을 가는 순간을 함께 지켜봐주세요"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "div-2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "p",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "span",
                                children: "이용식 "
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-wrapper-2",
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "span",
                                children: " 김삼례 "
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-wrapper-2",
                                children: "의 아들"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "span",
                                children: " 이정영"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "span",
                                children: " 유훈 "
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-wrapper-2",
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "span",
                                children: " 김미영 "
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-wrapper-2",
                                children: "의 딸"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "span",
                                children: " 유예진"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "div-2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "text",
                        children: [
                            "아들과 딸이 한 가정을 이루고자 혼인의 예를 올립니다",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            "두 자녀의 행복을 따듯한 마음으로 축복해 주시기 바랍니다"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "div",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "header-2",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "title-4",
                                children: "G A L L E R Y"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "gallery",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gallereactDefault.default), {
                                images: images,
                                cover: false,
                                swipe: true
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "div",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "header-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "header-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-2",
                                    children: "날짜 및 시간"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "title-5",
                                    children: "2023년 9월 16일 토요일 오후 5시"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "map",
                        id: "map"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "buttons",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "button",
                                onClick: ()=>window.open(NAVER_MAP_URL, "_blank"),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-3",
                                    children: "네이버 지도"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "div-wrapper",
                                onClick: ()=>window.open(KAKAO_MAP_URL, "_blank"),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-4",
                                    children: "카카오 네비"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "button-2",
                                onClick: ()=>window.open(TMAP_MAP_URL, "_blank"),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-3",
                                    children: "티맵"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "div",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "header-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-2",
                                    children: "오시는길"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "title-5",
                                    children: "서울시 영등포구 여의공원로 101 CCMM빌딩 12층 [루나미엘레]"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "feature-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icon",
                                        alt: "Icon",
                                        src: "/img/icon-2.svg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "title-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-5",
                                                children: "지하철"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "text-6",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "span",
                                                        children: "5호선 여의나루역 1번 출구 하차"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            " ",
                                                            "(LG쌍둥이 빌딩 여의도공원 건너편, 도보 10분)",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "span",
                                                        children: "9호선 국회의사당역 3번 출구 하차"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            " ",
                                                            "(여의도 공원 좌측 300M 지점, 도보 6분)"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "feature-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icon",
                                        alt: "Icon",
                                        src: "/img/icon-1.svg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "title-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-5",
                                                children: "버스"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "text-6",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "span",
                                                        children: [
                                                            "여의도공원 환승센터 하차",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            "(여의도 공원 건너편 CCMM빌딩)",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-4",
                                                        children: "일반버스"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            " ",
                                                            "10, 11-1, 11-2, 83, 88, 510, 5012, 5618",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-4",
                                                        children: "일반버스"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            " ",
                                                            "5623, 6623, 6628, 5615, 6513, 6654",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-4",
                                                        children: "간선버스"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            " ",
                                                            "160, 30, 162, 600, 260, 662, 261, 262",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-4",
                                                        children: "좌석버스"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            " ",
                                                            "301, 320, 871, 8600, 8601, 8601A, G6001, 5609",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "span",
                                                        children: [
                                                            "여의도 순복음교회 하차",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            "(여의도 공원 방향으로 200M)",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-4",
                                                        children: "일반버스"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            " ",
                                                            "10, 1002, 5615, 5618, 5633",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-4",
                                                        children: "일반버스"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            " ",
                                                            "5713, 7613, 5534, 6623",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-4",
                                                        children: "간선버스"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            " ",
                                                            "461, 753, 261, 463",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-4",
                                                        children: "좌석버스"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-3",
                                                        children: " 7007-1, 108"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "feature-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icon",
                                        alt: "Icon",
                                        src: "/img/icon.svg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "title-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-5",
                                                children: "자가용"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "text-6",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "span",
                                                        children: [
                                                            "강남방면",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            "88올림픽대로 > 63빌딩 > 여의도 공원 직진 > ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                            "국민일보 빌딩 > 지하 주차장",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "span",
                                                        children: [
                                                            "강북방면",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-wrapper-3",
                                                        children: [
                                                            "서강대교 이용 > 순복음교회 좌회전 > 태영빌딩 좌회전 >",
                                                            " ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                            "국민일보 빌딩 > 지하주차장",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                            "마포대교 이용 > 우회전 후 태영빌딩 좌회전 > ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                            "국민일보 빌딩 > 지하주차장"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "image-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "image",
                                    alt: "Image",
                                    src: "/img/image-5.png"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "div",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "header-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title-6",
                                    children: "마음 전하실 곳"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-7",
                                    children: "신랑 & 신부에게 축하의 마음을 전해주세요"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "buttons-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "button-31",
                                onClick: ()=>setIsAccount1Open(true),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-8",
                                    children: "신랑측 계좌번호"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "button-32",
                                onClick: ()=>setIsAccount2Open(true),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-8",
                                    children: "신부측 계좌번호"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "div",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "header-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title-6",
                                    children: "연락처"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-7",
                                    children: "신랑 신부 그리고 혼주 연락처"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "buttons-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "button-4",
                                onClick: ()=>setIsContact1Open(true),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-9",
                                    children: "신랑측 연락처 확인하기"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "button-4",
                                onClick: ()=>setIsContact2Open(true),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-9",
                                    children: "신부측 연락처 확인하기"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "div",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "header-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-wrapper",
                                    children: "서울 여의도 루나미엘레 그랜드볼룸"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "title-5",
                                    children: "2023년 9월 16일 오후 5시"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "buttons",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "button-5",
                                id: "kakaotalk-sharing-btn",
                                onClick: ()=>{
                                    Kakao.Share.createDefaultButton({
                                        container: "#kakaotalk-sharing-btn",
                                        objectType: "feed",
                                        content: {
                                            title: "이정영 & 유예진 결혼합니다.",
                                            description: "2023년 9월 16일 토요일 오후 5시\n서울 여의도 루나미엘레 그랜드볼룸",
                                            imageUrl: "https://jeongyoungyejin.com/img/mobile-cover3.jpeg",
                                            link: {
                                                // [내 애플리케이션] > [플랫폼] 에서 등록한 사이트 도메인과 일치해야 함
                                                mobileWebUrl: "https://jeongyoungyejin.com",
                                                webUrl: "https://jeongyoungyejin.com"
                                            }
                                        },
                                        buttons: [
                                            {
                                                title: "모바일 청첩장 보기",
                                                link: {
                                                    mobileWebUrl: "https://jeongyoungyejin.com",
                                                    webUrl: "https://jeongyoungyejin.com"
                                                }
                                            }
                                        ]
                                    });
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-10",
                                    children: "카카오톡 공유"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "button-6",
                                onClick: ()=>copyClipBoard(`https://jeongyoungyejin.com`),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-11",
                                    children: "URL 주소 복사"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "button-6",
                                onClick: ()=>{
                                    (0, _fileSaver.saveAs)("https://jeongyoungyejin.com/img/wedding-rsvp.png", "이정영유예진청첩장.png");
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-12",
                                    children: "청첩장 다운로드"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("footer", {
                className: "footer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "img",
                            alt: "Frame",
                            src: "/img/frame-5.svg"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-13",
                            children: "\xa9 2023 JeongYoung Lee. All Rights Reserved."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccountDialog, {
                isOpen: isAccount1Open,
                closeModal: ()=>setIsAccount1Open(false),
                title: `신랑측 마음 전하실 곳`,
                accounts: ACCOUNTS1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccountDialog, {
                isOpen: isAccount2Open,
                closeModal: ()=>setIsAccount2Open(false),
                title: `신부측 마음 전하실 곳`,
                accounts: ACCOUNTS2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContactDialog, {
                isOpen: isContact1Open,
                closeModal: ()=>setIsContact1Open(false),
                title: `신랑측 전화번호`,
                contacts: CONTACTS1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContactDialog, {
                isOpen: isContact2Open,
                closeModal: ()=>setIsContact2Open(false),
                title: `신부측 전화번호`,
                contacts: CONTACTS2
            })
        ]
    });
};
const AccountDialog = ({ isOpen, closeModal, title, accounts })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Transition), {
        appear: true,
        show: isOpen,
        as: (0, _react.Fragment),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react1.Dialog), {
            as: "div",
            className: "relative z-10",
            onClose: closeModal,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Transition).Child, {
                    as: (0, _react.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "fixed inset-0 bg-black bg-opacity-25"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "fixed inset-0 overflow-y-auto",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex min-h-full items-center justify-center p-4 text-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Transition).Child, {
                            as: (0, _react.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react1.Dialog).Panel, {
                                className: "w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react1.Dialog).Title, {
                                        as: "h3",
                                        className: "text-4xl font-medium text-gray-900",
                                        children: [
                                            title,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "absolute top-4 right-4 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white",
                                                "data-modal-hide": "defaultModal",
                                                onClick: closeModal,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        className: "w-3 h-3",
                                                        "aria-hidden": "true",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 14 14",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            stroke: "currentColor",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "2",
                                                            d: "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Close modal"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mt-8",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "flex flex-row justify-between items-center text-gray-600 text-2xl",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            accounts[0][0],
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: accounts[0][1]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            className: "ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-2xl font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                                                            onClick: ()=>copyClipBoard(accounts[0][1]),
                                                            children: "계좌번호 복사"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "flex flex-row justify-between items-center mt-3 text-gray-600 text-2xl",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            accounts[1][0],
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: accounts[1][1]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            className: "ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-2xl font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                                                            onClick: ()=>copyClipBoard(accounts[1][1]),
                                                            children: "계좌번호 복사"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "flex flex-row justify-between items-center mt-3 text-gray-600 text-2xl",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            accounts[2][0],
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: accounts[2][1]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            className: "ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-2xl font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                                                            onClick: ()=>copyClipBoard(accounts[2][1]),
                                                            children: "계좌번호 복사"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
const ContactDialog = ({ isOpen, closeModal, title, contacts })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Transition), {
        appear: true,
        show: isOpen,
        as: (0, _react.Fragment),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react1.Dialog), {
            as: "div",
            className: "relative z-10",
            onClose: closeModal,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Transition).Child, {
                    as: (0, _react.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "fixed inset-0 bg-black bg-opacity-25"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "fixed inset-0 overflow-y-auto",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex min-h-full items-center justify-center p-4 text-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Transition).Child, {
                            as: (0, _react.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react1.Dialog).Panel, {
                                className: "w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react1.Dialog).Title, {
                                        as: "h3",
                                        className: "text-4xl font-medium text-gray-900",
                                        children: [
                                            title,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "absolute top-4 right-4 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white",
                                                "data-modal-hide": "defaultModal",
                                                onClick: closeModal,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        className: "w-3 h-3",
                                                        "aria-hidden": "true",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 14 14",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            stroke: "currentColor",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "2",
                                                            d: "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Close modal"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mt-8",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "flex flex-row justify-between items-center text-gray-600 text-2xl",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            contacts[0][0],
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: contacts[0][1]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                className: "inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-2xl font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                                                                onClick: ()=>window.open(`tel:${contacts[0][1]}`, "_blank"),
                                                                children: "\uD83D\uDCDE 전화하기"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                className: "ml-4 inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-2xl font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2",
                                                                onClick: ()=>window.open(`sms:${contacts[0][1]}`, "_blank"),
                                                                children: "✉️ 문자하기"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "flex flex-row justify-between items-center mt-3 text-gray-600 text-2xl",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            contacts[1][0],
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: contacts[1][1]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                className: "inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-2xl font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                                                                onClick: ()=>window.open(`tel:${contacts[1][1]}`, "_blank"),
                                                                children: "\uD83D\uDCDE 전화하기"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                className: "ml-4 inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-2xl font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2",
                                                                onClick: ()=>window.open(`sms:${contacts[1][1]}`, "_blank"),
                                                                children: "✉️ 문자하기"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "flex flex-row justify-between items-center mt-3 text-gray-600 text-2xl",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            contacts[2][0],
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: contacts[2][1]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                className: "inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-2xl font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                                                                onClick: ()=>window.open(`tel:${contacts[2][1]}`, "_blank"),
                                                                children: "\uD83D\uDCDE 전화하기"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                className: "ml-4 inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-2xl font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2",
                                                                onClick: ()=>window.open(`sms:${contacts[2][1]}`, "_blank"),
                                                                children: "✉️ 문자하기"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });

},{"react/jsx-runtime":"gaGEj","react":"6uln9","gallereact":"iVTUd","@headlessui/react":"4at9Y","./style.css":"7gz5g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151","file-saver":"hasfJ"}],"iVTUd":[function(require,module,exports) {
module.exports = function(e) {
    var n = {};
    function t(r) {
        if (n[r]) return n[r].exports;
        var o = n[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    return t.m = e, t.c = n, t.d = function(e, n, r) {
        t.o(e, n) || Object.defineProperty(e, n, {
            enumerable: !0,
            get: r
        });
    }, t.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, t.t = function(e, n) {
        if (1 & n && (e = t(e)), 8 & n) return e;
        if (4 & n && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (t.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
        }), 2 & n && "string" != typeof e) for(var o in e)t.d(r, o, (function(n) {
            return e[n];
        }).bind(null, o));
        return r;
    }, t.n = function(e) {
        var n = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return t.d(n, "a", n), n;
    }, t.o = function(e, n) {
        return Object.prototype.hasOwnProperty.call(e, n);
    }, t.p = "", t(t.s = 5);
}([
    function(e, n) {
        e.exports = require("e1a4d36485aa51cc");
    },
    function(e, n, t) {
        e.exports = t(3)();
    },
    function(e, n) {
        e.exports = require("13b7b10dbcd1d15e");
    },
    function(e, n, t) {
        "use strict";
        var r = t(4);
        function o() {}
        function i() {}
        i.resetWarningCache = o, e.exports = function() {
            function e(e, n, t, o, i, a) {
                if (a !== r) {
                    var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    throw c.name = "Invariant Violation", c;
                }
            }
            function n() {
                return e;
            }
            e.isRequired = e;
            var t = {
                array: e,
                bool: e,
                func: e,
                number: e,
                object: e,
                string: e,
                symbol: e,
                any: e,
                arrayOf: n,
                element: e,
                elementType: e,
                instanceOf: n,
                node: e,
                objectOf: n,
                oneOf: n,
                oneOfType: n,
                shape: n,
                exact: n,
                checkPropTypes: i,
                resetWarningCache: o
            };
            return t.PropTypes = t, t;
        };
    },
    function(e, n, t) {
        "use strict";
        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    },
    function(e, n, t) {
        "use strict";
        t.r(n);
        var r = t(0), o = t.n(r), i = t(1), a = t.n(i), c = Object(r.createContext)({}), u = c.Provider, l = c;
        function s(e) {
            for(var n = 1; n < arguments.length; n++)if (n % 2) {
                var t = null != arguments[n] ? arguments[n] : {}, r = Object.keys(t);
                "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                }))), r.forEach(function(n) {
                    f(e, n, t[n]);
                });
            } else Object.defineProperties(e, Object.getOwnPropertyDescriptors(arguments[n]));
            return e;
        }
        function f(e, n, t) {
            return n in e ? Object.defineProperty(e, n, {
                value: t,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[n] = t, e;
        }
        function d(e, n) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e) || function(e, n) {
                var t = [], r = !0, o = !1, i = void 0;
                try {
                    for(var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (t.push(a.value), !n || t.length !== n); r = !0);
                } catch (e) {
                    o = !0, i = e;
                } finally{
                    try {
                        r || null == c.return || c.return();
                    } finally{
                        if (o) throw i;
                    }
                }
                return t;
            }(e, n) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            }();
        }
        var p = {
            translateDrag: 0,
            translateDuration: .5,
            x0: null
        }, y = function(e, n, t, o) {
            var i = d(Object(r.useState)(p), 2), a = i[0], c = i[1];
            if (Object(r.useEffect)(function() {
                return o && (document.addEventListener("mouseup", u, !1), document.addEventListener("touchend", u, !1)), function() {
                    document.removeEventListener("mouseup", u), document.removeEventListener("touchend", u);
                };
            }, []), !o) return null;
            var u = function() {
                c(p);
            }, l = function(r) {
                if (a.x0) {
                    var o = v(r).clientX, i = o - a.x0, u = Math.sign(i), l = +(u * i / n).toFixed(2);
                    if (c({
                        x0: null,
                        translateDrag: 0,
                        translateDuration: 1 - l
                    }), l > .2) t(e - u);
                    else if (0 === l) {
                        var s = r.target.getBoundingClientRect(), f = s.x, d = s.width, y = o - f;
                        u = Math.sign(d / 2 - y), t(e - u);
                    }
                } else c(p);
            }, f = function(e) {
                var n = v(e).clientX;
                c(function(e) {
                    return s({}, e, {
                        x0: n,
                        translateDuration: 0
                    });
                });
            }, y = function(e) {
                if (a.x0) {
                    var n = v(e).clientX;
                    c(function(e) {
                        return s({}, e, {
                            translateDrag: Math.round(n - e.x0)
                        });
                    });
                }
            }, v = function(e) {
                return e.changedTouches ? e.changedTouches[0] : e;
            };
            return {
                listeners: {
                    onTouchStart: f,
                    onTouchMove: y,
                    onTouchEnd: l,
                    onMouseDown: f,
                    onMouseMove: y,
                    onMouseUp: l
                },
                translateState: a
            };
        }, v = t(2), b = t.n(v);
        function m() {
            var e = q([
                "\n  background-image: url(",
                ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: inline-block;\n  width: ",
                ";\n  min-width: ",
                ";\n  height: 100%;\n  margin: 0px;\n  cursor: pointer;\n  border: ",
                ";\n  transition: border 0.5s;\n"
            ]);
            return m = function() {
                return e;
            }, e;
        }
        function g() {
            var e = q([
                "\n  position: relative;\n  bottom: 0;\n  width: 100%;\n  height: 10%;\n  margin: auto;\n  display: ",
                ";\n  align-items: center;\n  z-index: 10;\n  transform: translate(0, -0%);\n  overflow: hidden;\n  overflow-x: scroll;\n"
            ]);
            return g = function() {
                return e;
            }, e;
        }
        function h() {
            var e = q([
                "\n  background: ",
                ";\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin: 0 10px;\n  cursor: pointer;\n  border-radius: 50%;\n"
            ]);
            return h = function() {
                return e;
            }, e;
        }
        function w() {
            var e = q([
                "\n  flex: 1;\n  bottom: 0;\n  width: 100%;\n  height: 10%;\n  margin: auto;\n  display: ",
                ";\n  justify-content: center;\n  align-items: center;\n  transform: translate(0, -0%);\n"
            ]);
            return w = function() {
                return e;
            }, e;
        }
        function O() {
            var e = q([
                "\n  border: solid ",
                ";\n  border-width: 0 4px 4px 0;\n  display: ",
                ";\n  margin: 20px;\n  padding: 7px;\n  transform: rotate(",
                ");\n"
            ]);
            return O = function() {
                return e;
            }, e;
        }
        function x() {
            var e = q([
                "\n  width: 40%;\n  height: 100%;\n  cursor: pointer;\n  align-items: center;\n  display: flex;\n  opacity: ",
                ";\n  justify-content: ",
                ";\n  img {\n    width: 40px;\n    transform: translate(0, -50%);\n    transition: opacity 0.4s;\n  }\n  transition: opacity 0.3s ease;\n  &:hover {\n    opacity: 1;\n  }\n"
            ]);
            return x = function() {
                return e;
            }, e;
        }
        function j() {
            var e = q([
                "\n  position: relative;\n  z-index: 5;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transform: translate(0, -100%);\n  user-select: none;\n"
            ]);
            return j = function() {
                return e;
            }, e;
        }
        function S() {
            var e = q([
                "\n  width: 100%;\n  white-space: normal;\n"
            ]);
            return S = function() {
                return e;
            }, e;
        }
        function E() {
            var e = q([
                "\n  margin: 10px;\n  margin-bottom: 5px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
            ]);
            return E = function() {
                return e;
            }, e;
        }
        function P() {
            var e = q([
                "\n  background: #fffa;\n  color: #333;\n  text-align: center;\n  width: 100.5%;\n  position: absolute;\n  padding: 15px 20px;\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n"
            ]);
            return P = function() {
                return e;
            }, e;
        }
        function C() {
            var e = q([
                "\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  object-position: center;\n  object-fit: ",
                ";\n  pointer-events: none;\n"
            ]);
            return C = function() {
                return e;
            }, e;
        }
        function T() {
            var e = q([
                "\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  /* background-image: url(",
                ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: ",
                "; */\n"
            ]);
            return T = function() {
                return e;
            }, e;
        }
        function k() {
            var e = q([
                "\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n"
            ]);
            return k = function() {
                return e;
            }, e;
        }
        function R() {
            var e = q([
                "\n  overflow: hidden;\n  white-space: nowrap;\n  height: 90%;\n  width: 100%;\n"
            ]);
            return R = function() {
                return e;
            }, e;
        }
        function q(e, n) {
            return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
                raw: {
                    value: Object.freeze(n)
                }
            }));
        }
        var A = b.a.div(R()), D = b.a.div.attrs(function(e) {
            var n = e.width, t = e.index, r = e.translateDrag, o = void 0 === r ? 0 : r, i = e.transition, a = e.translateDuration, c = void 0 === a ? .5 : a;
            return {
                style: {
                    transform: "translateX(".concat(-100 * t + o / n * 100, "%)"),
                    transition: i && "transform cubic-bezier(0,.59,.46,1) ".concat(c, "s")
                }
            };
        })(k()), _ = b.a.div(T(), function(e) {
            return e.image;
        }, function(e) {
            return e.cover ? "cover" : "contain";
        }), I = b.a.img(C(), function(e) {
            return e.cover ? "cover" : "contain";
        }), M = b.a.div(P()), z = b.a.div(E()), L = b.a.p(S()), H = b.a.div(j()), X = b.a.div(x(), function(e) {
            return e.hover ? "0" : "1";
        }, function(e) {
            return "left" === e.direction ? "flex-start" : "flex-end";
        }), B = b.a.div(O(), function(e) {
            return e.primaryColor;
        }, function(e) {
            return e.displayArrows ? "flex" : "none";
        }, function(e) {
            return "left" === e.direction ? "135deg" : "-45deg";
        }), U = b.a.div(w(), function(e) {
            return e.displayDot ? "flex" : "none";
        }), W = b.a.div(h(), function(e) {
            var n = e.active, t = e.colors;
            return n ? t.b : t.a;
        }), F = b.a.div(g(), function(e) {
            return e.displayPreview ? "flex" : "none";
        }), N = b.a.div(m(), function(e) {
            return e.image;
        }, function(e) {
            var n = e.length;
            return "".concat(100 / n, "%");
        }, function() {
            return "".concat(10, "%");
        }, function(e) {
            var n = e.active, t = e.color;
            return n ? "solid 3px ".concat(t) : "solid 0px ".concat(t);
        });
        function V(e) {
            var n = e.curr, t = e.taglineStyle, r = e.titleStyle, i = e.captionStyle;
            return n.title || n.caption ? o.a.createElement(M, {
                style: t
            }, o.a.createElement(z, {
                style: r
            }, n.title), o.a.createElement(L, {
                style: i
            }, n.caption)) : null;
        }
        V.propTypes = {
            curr: a.a.objectOf(a.a.strings).isRequired,
            taglineStyle: a.a.object.isRequired,
            titleStyle: a.a.object.isRequired,
            captionStyle: a.a.object.isRequired
        };
        var Y = o.a.memo(V);
        function G() {
            return (G = Object.assign || function(e) {
                for(var n = 1; n < arguments.length; n++){
                    var t = arguments[n];
                    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function J(e, n, t) {
            return n in e ? Object.defineProperty(e, n, {
                value: t,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[n] = t, e;
        }
        var K = function() {
            var e = Object(r.useContext)(l), n = e.index, t = e.images, i = e.cover, a = void 0 === i || i, c = e.transition, u = void 0 === c || c, s = e.swipe, f = void 0 !== s && s, d = e.goToSlide, p = e.slideStyle, v = e.taglineStyle, b = e.titleStyle, m = e.captionStyle, g = e.children, h = Object(r.useRef)(), w = h.current && h.current.getBoundingClientRect().width, O = y(n, w, d, f), x = Object(r.useMemo)(function() {
                return t.map(function(e, n) {
                    return g ? o.a.createElement(_, {
                        key: n
                    }, g(e, n)) : o.a.createElement(_, {
                        key: n,
                        style: p
                    }, o.a.createElement(I, {
                        cover: a,
                        src: e.image || e,
                        alt: "(slide ".concat(n + 1, ")")
                    }), o.a.createElement(Y, {
                        curr: e,
                        taglineStyle: v,
                        titleStyle: b,
                        captionStyle: m
                    }));
                });
            }, [
                t,
                p,
                a,
                v,
                b,
                m
            ]), j = f && O && function(e) {
                for(var n = 1; n < arguments.length; n++)if (n % 2) {
                    var t = null != arguments[n] ? arguments[n] : {}, r = Object.keys(t);
                    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    }))), r.forEach(function(n) {
                        J(e, n, t[n]);
                    });
                } else Object.defineProperties(e, Object.getOwnPropertyDescriptors(arguments[n]));
                return e;
            }({}, O.listeners, {}, O.translateState);
            return o.a.createElement(D, G({
                ref: h,
                width: w,
                transition: f || u,
                index: n
            }, j), x);
        }, Q = function(e) {
            var n = e.callToAction, t = e.direction, r = e.arrowStyle, i = e.arrowAreaStyle, a = e.displayArrows, c = e.arrowOnHover, u = e.arrowImg, l = e.primaryColor;
            return o.a.createElement(X, {
                style: i,
                direction: t,
                hover: c,
                onClick: n
            }, u ? o.a.createElement("img", {
                src: u,
                style: r,
                alt: ""
            }) : o.a.createElement(B, {
                displayArrows: a,
                direction: t,
                style: r,
                primaryColor: l
            }));
        };
        Q.propTypes = {
            callToAction: a.a.func.isRequired,
            direction: a.a.string.isRequired,
            arrowStyle: a.a.object.isRequired,
            arrowAreaStyle: a.a.object.isRequired,
            displayArrows: a.a.bool.isRequired,
            arrowOnHover: a.a.bool.isRequired,
            arrowImg: a.a.string.isRequired,
            primaryColor: a.a.string.isRequired
        };
        var Z = o.a.memo(Q), $ = function() {
            var e = Object(r.useContext)(l), n = e.arrowStyle, t = e.arrowsContainerStyle, i = e.arrowAreaStyle, a = e.displayArrows, c = void 0 === a || a, u = e.arrowOnHover, s = void 0 !== u && u, f = e.primaryColor, d = void 0 === f ? "#CCC" : f, p = e.arrowLeftImg, y = e.arrowRightImg, v = e.goToSlide, b = e.swipe, m = void 0 !== b && b, g = e.images, h = e.index, w = e.loop, O = void 0 === w || w, x = Object(r.useCallback)(function() {
                v("prev");
            }, [
                O,
                m,
                g
            ]), j = Object(r.useCallback)(function() {
                v("next");
            }, [
                O,
                m,
                g
            ]);
            return !m && o.a.createElement(H, {
                style: t
            }, O || h > 0 ? o.a.createElement(Z, {
                arrowStyle: n,
                arrowAreaStyle: i,
                displayArrows: c,
                arrowOnHover: s,
                primaryColor: d,
                arrowImg: p,
                callToAction: x,
                direction: "left"
            }) : o.a.createElement("div", null), O || h < g.length - 1 ? o.a.createElement(Z, {
                arrowStyle: n,
                arrowAreaStyle: i,
                displayArrows: c,
                arrowOnHover: s,
                primaryColor: d,
                arrowImg: y,
                callToAction: j,
                direction: "right"
            }) : o.a.createElement("div", null));
        }, ee = function() {
            var e = Object(r.useContext)(l), n = e.index, t = e.images, i = e.goToSlide, a = e.dotStyle, c = e.dotActiveStyle, u = e.displayDot, s = void 0 === u || u, f = e.primaryColor, d = void 0 === f ? "#CCC" : f, p = e.secondaryColor, y = void 0 === p ? "#333" : p, v = e.dotsContainerStyle, b = function(e) {
                e === n || i(e);
            }, m = Object.assign({}, a, c);
            return o.a.createElement(U, {
                displayDot: s,
                style: v
            }, t.map(function(e, t) {
                return o.a.createElement(W, {
                    key: t,
                    style: t === n ? m : a,
                    active: t === n,
                    colors: {
                        a: d,
                        b: y
                    },
                    onClick: b.bind(null, t)
                });
            }));
        }, ne = function() {
            var e = Object(r.useContext)(l), n = e.index, t = e.images, i = e.goToSlide, a = e.previewStyle, c = e.previewActiveStyle, u = e.displayPreview, s = void 0 === u || u, f = e.primaryColor, d = void 0 === f ? "#CCC" : f, p = function(e) {
                e === n || i(e);
            }, y = Object.assign({}, a, c);
            return o.a.createElement(F, {
                displayPreview: s
            }, t.map(function(e, r) {
                return o.a.createElement(N, {
                    key: r,
                    style: r === n ? y : a,
                    active: r === n,
                    length: t.length,
                    image: e.image,
                    color: d,
                    onClick: p.bind(null, r)
                });
            }));
        };
        function te(e) {
            for(var n = 1; n < arguments.length; n++)if (n % 2) {
                var t = null != arguments[n] ? arguments[n] : {}, r = Object.keys(t);
                "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                }))), r.forEach(function(n) {
                    re(e, n, t[n]);
                });
            } else Object.defineProperties(e, Object.getOwnPropertyDescriptors(arguments[n]));
            return e;
        }
        function re(e, n, t) {
            return n in e ? Object.defineProperty(e, n, {
                value: t,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[n] = t, e;
        }
        function oe(e, n) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e) || function(e, n) {
                var t = [], r = !0, o = !1, i = void 0;
                try {
                    for(var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (t.push(a.value), !n || t.length !== n); r = !0);
                } catch (e) {
                    o = !0, i = e;
                } finally{
                    try {
                        r || null == c.return || c.return();
                    } finally{
                        if (o) throw i;
                    }
                }
                return t;
            }(e, n) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            }();
        }
        var ie = function(e) {
            var n = e.loop, t = void 0 === n || n, i = e.callback, a = e.containerStyle, c = e.autoPlay, l = e.duration, s = void 0 === l ? 2e3 : l, f = e.inputIndex, d = e.images, p = void 0 === d ? [] : d, y = e.swipe, v = void 0 !== y && y, b = e.displayPreview, m = void 0 !== b && b, g = oe(Object(r.useState)(0), 2), h = g[0], w = g[1];
            Object(r.useEffect)(function() {
                var e = c && setTimeout(goToNextSlide, s);
                return function() {
                    return clearTimeout(e);
                };
            }, [
                h,
                c
            ]), Object(r.useEffect)(function() {
                "number" == typeof f && O(f);
            }, [
                f
            ]);
            var O = function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                w(function(n) {
                    return "next" === e ? n < p.length - 1 ? e = n + 1 : !v && t && (e = 0) : "prev" === e && (n > 0 ? e = n - 1 : !v && t && (e = p.length - 1)), e < 0 || e > p.length - 1 ? n : (i && i(e), e);
                });
            };
            return p.length ? o.a.createElement(u, {
                value: te({}, e, {
                    index: h,
                    goToSlide: O
                })
            }, o.a.createElement(A, {
                style: a
            }, o.a.createElement(K, null), o.a.createElement($, null)), m ? o.a.createElement(ne, null) : o.a.createElement(ee, null)) : null;
        };
        ie.propTypes = {
            cover: a.a.bool.isRequired,
            loop: a.a.bool.isRequired,
            duration: a.a.bool.isRequired,
            swipe: a.a.bool.isRequired,
            autoPlay: a.a.bool.isRequired,
            displayPreview: a.a.bool.isRequired,
            callback: a.a.func.isRequired,
            inputIndex: a.a.number.isRequired,
            containerStyle: a.a.object,
            images: a.a.array
        };
        var ae = ie;
        t.d(n, "default", function() {
            return ae;
        });
    }
]);

},{"e1a4d36485aa51cc":"6uln9","13b7b10dbcd1d15e":"byVI1"}],"byVI1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGlobalStyle", ()=>createGlobalStyle);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "isStyledComponent", ()=>isStyledComponent);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
parcelHelpers.export(exports, "ServerStyleSheet", ()=>ServerStyleSheet);
parcelHelpers.export(exports, "StyleSheetConsumer", ()=>StyleSheetConsumer);
parcelHelpers.export(exports, "StyleSheetContext", ()=>StyleSheetContext);
parcelHelpers.export(exports, "StyleSheetManager", ()=>StyleSheetManager);
parcelHelpers.export(exports, "ThemeConsumer", ()=>ThemeConsumer);
parcelHelpers.export(exports, "ThemeContext", ()=>ThemeContext);
parcelHelpers.export(exports, "ThemeProvider", ()=>ThemeProvider);
parcelHelpers.export(exports, "withTheme", ()=>withTheme);
parcelHelpers.export(exports, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", ()=>__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS);
var _stylisMin = require("stylis/stylis.min");
var _stylisMinDefault = parcelHelpers.interopDefault(_stylisMin);
var _stylisRuleSheet = require("stylis-rule-sheet");
var _stylisRuleSheetDefault = parcelHelpers.interopDefault(_stylisRuleSheet);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _reactIs = require("react-is");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _mergeAnything = require("merge-anything");
var _mergeAnythingDefault = parcelHelpers.interopDefault(_mergeAnything);
var process = require("50571207bc3cae02");
// 
var interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var isPlainObject = function(x) {
    return (typeof x === "undefined" ? "undefined" : _typeof(x)) === "object" && x.constructor === Object;
};
// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});
// 
function isFunction(test) {
    return typeof test === "function";
}
// 
function getComponentName(target) {
    return (0, target.displayName) || target.name || "Component";
}
// 
function isStatelessFunction(test) {
    return typeof test === "function" && !(test.prototype && test.prototype.isReactComponent);
}
// 
function isStyledComponent(target) {
    return target && typeof target.styledComponentId === "string";
}
// 
var SC_ATTR = (typeof process !== "undefined" && undefined, "data-styled");
var SC_VERSION_ATTR = "data-styled-version";
var SC_STREAM_ATTR = "data-styled-streamed";
var IS_BROWSER = typeof window !== "undefined" && "HTMLElement" in window;
var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === "boolean" && SC_DISABLE_SPEEDY || typeof process !== "undefined" && undefined || false;
// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var ERRORS = {};
/**
 * super basic version of sprintf
 */ function format() {
    var a = arguments.length <= 0 ? undefined : arguments[0];
    var b = [];
    for(var c = 1, len = arguments.length; c < len; c += 1)b.push(arguments.length <= c ? undefined : arguments[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var StyledComponentsError = function(_Error) {
    inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        classCallCheck(this, StyledComponentsError);
        for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
        var _this;
        var _this = possibleConstructorReturn(this, _Error.call(this, "An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + code + " for more information." + (interpolations.length > 0 ? " Additional arguments: " + interpolations.join(", ") : "")));
        return possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var extractComps = function(maybeCSS) {
    var css = "" + (maybeCSS || ""); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace(SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
var COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new (0, _stylisMinDefault.default)({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var stylis = new (0, _stylisMinDefault.default)({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = parsingRules;
        parsingRules = [];
        return parsedRules;
    }
};
var parseRulesPlugin = (0, _stylisRuleSheetDefault.default)(function(rule) {
    parsingRules.push(rule);
});
var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;
var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
    if (// the first self-ref is always untouched
    offset > 0 && // there should be at least two self-refs to do a replacement (.b > .b)
    string.slice(0, offset).indexOf(_selector) !== -1 && // no consecutive self refs (.b.b); that is a precedence boost and treated differently
    string.slice(offset - _selector.length, offset) !== _selector) return "." + _componentId;
    return match;
};
/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */ var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
    if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
};
stylis.use([
    selfReferenceReplacementPlugin,
    parseRulesPlugin,
    returnRulesPlugin
]);
stylisSplitter.use([
    parseRulesPlugin,
    returnRulesPlugin
]);
var splitByRules = function splitByRules(css) {
    return stylisSplitter("", css);
};
function stringifyRules(rules, selector, prefix) {
    var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "&";
    var flatCSS = rules.join("").replace(COMMENT_REGEX, ""); // replace JS comments
    var cssStr = selector && prefix ? prefix + " " + selector + " { " + flatCSS + " }" : flatCSS;
    // stylis has no concept of state to be passed to plugins
    // but since JS is single=threaded, we can rely on that to ensure
    // these properties stay in sync with the current stylis run
    _componentId = componentId;
    _selector = selector;
    _selectorRegexp = new RegExp("\\" + _selector + "\\b", "g");
    return stylis(prefix || !selector ? "" : selector, cssStr);
}
// 
/* eslint-disable camelcase, no-undef */ var getNonce = function() {
    return typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : null;
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var stringifyNames = function stringifyNames(names) {
    var str = "";
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(" ") + " ";
    return str.trim();
};
/* clones the nested names dictionary */ var cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = _extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = tag.ownerDocument.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = tag.ownerDocument.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var makeTextMarker = function makeTextMarker(id) {
    return "\n/* sc-component-id: " + id + " */\n";
};
/* add up all numbers in array up until and including the index */ var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var targetDocument = document;
    if (target) targetDocument = target.ownerDocument;
    else if (tagEl) targetDocument = tagEl.ownerDocument;
    var el = targetDocument.createElement("style");
    el.setAttribute(SC_ATTR, "");
    el.setAttribute(SC_VERSION_ATTR, "4.4.1");
    var nonce = getNonce();
    if (nonce) el.setAttribute("nonce", nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(targetDocument.createTextNode(""));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            SC_ATTR + '="' + stringifyNames(names) + '"',
            SC_VERSION_ATTR + '="' + "4.4.1" + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(" ");
        return "<style " + htmlAttr + ">" + css() + "</style>";
    };
};
/* takes a css factory function and outputs an element factory */ var wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);
        var nonce = getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, _reactDefault.default).createElement("style", _extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whether getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = sheetForTag(el);
        var insertIndex = addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf("@import") !== -1) importRules.push(cssRule);
            else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + "-import", importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        // $FlowFixMe
        if (el.isConnected === false) return;
        var size = sizes[marker];
        var sheet = sheetForTag(el);
        var removalIndex = addUpUntilIndex(sizes, marker) - 1;
        deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + "-import");
    };
    var css = function css() {
        var _sheetForTag = sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += makeTextMarker(id);
            var marker = markers[id];
            var end = addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new StyledComponentsError(5);
        },
        css: css,
        getIds: getIdsFromMarkersFactory(markers),
        hasNameForId: hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: wrapAsElement(css, names),
        toHTML: wrapAsHtmlTag(css, names)
    };
};
var makeTextNode = function makeTextNode(targetDocument, id) {
    return targetDocument.createTextNode(makeTextMarker(id));
};
var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whether getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = makeTextNode(el.ownerDocument, id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf("@import") !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? "" : " ";
                marker.appendData("" + rule + separator);
            }
        }
        addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + "-import", importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = makeTextNode(el.ownerDocument, id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + "-import");
    };
    var css = function css() {
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new StyledComponentsError(5);
        },
        css: css,
        getIds: getIdsFromMarkersFactory(markers),
        hasNameForId: hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: wrapAsElement(css, names),
        toHTML: wrapAsHtmlTag(css, names)
    };
};
var makeServerTag = function makeServerTag(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ""
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(" ");
        addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = "";
        resetIdNames(names, id);
    };
    var css = function css() {
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTag(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: getIdsFromMarkersFactory(markers),
        hasNameForId: hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: wrapAsElement(css, names),
        toHTML: wrapAsHtmlTag(css, names)
    };
    return tag;
};
var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if (IS_BROWSER && !forceServer) {
        var el = makeStyleTag(target, tagEl, insertBefore);
        if (DISABLE_SPEEDY) return makeBrowserTag(el, getImportRuleTag);
        else return makeSpeedyTag(el, getImportRuleTag);
    }
    return makeServerTag();
};
var rehydrate = function rehydrate(tag, els, extracted) {
    /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
        var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
        var cssRules = splitByRules(cssFromDOM);
        tag.insertRules(componentId, cssRules);
    }
    /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
        var el = els[_i];
        if (el.parentNode) el.parentNode.removeChild(el);
    }
};
// 
var SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var MAX_SIZE = void 0;
if (IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ MAX_SIZE = -1;
var sheetRunningId = 0;
var master = void 0;
var StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        sheetRunningId += 1;
        this.id = sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate$$1() {
        if (!IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll("style[" + SC_ATTR + "][" + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (!nodesSize) return this;
        for(var i = 0; i < nodesSize; i += 1){
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute(SC_ATTR) || "").trim().split(SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0, name; j < elNamesSize; j += 1){
                name = elNames[j];
                /* add rehydrated name to sheet to avoid re-adding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (!extractedSize) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        rehydrate(tag, els, extracted);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, MAX_SIZE - extractedSize);
        this.tags.push(tag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = tag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = _extends({}, this.rehydratedNames);
        sheet.deferred = _extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for createGlobalStyle to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join("");
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = "sc-" + id + "-" + i;
            return (0, _react.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    createClass(StyleSheet, null, [
        {
            key: "master",
            get: function get$$1() {
                return master || (master = new StyleSheet().rehydrate());
            }
        },
        {
            key: "instance",
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
// 
var Keyframes = function() {
    function Keyframes(name, rules) {
        var _this = this;
        classCallCheck(this, Keyframes);
        this.inject = function(styleSheet) {
            if (!styleSheet.hasNameForId(_this.id, _this.name)) styleSheet.inject(_this.id, _this.rules, _this.name);
        };
        this.toString = function() {
            throw new StyledComponentsError(12, String(_this.name));
        };
        this.name = name;
        this.rules = rules;
        this.id = "sc-keyframes-" + name;
    }
    Keyframes.prototype.getName = function getName() {
        return this.name;
    };
    return Keyframes;
}();
// 
/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */ var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function hyphenateStyleName(string) {
    return string.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
}
// 
// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
    // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
    // $FlowFixMe
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !(name in (0, _unitlessDefault.default))) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
    return String(value).trim();
}
// 
/**
 * It's falsish not falsy because 0 is allowed.
 */ var isFalsish = function isFalsish(chunk) {
    return chunk === undefined || chunk === null || chunk === false || chunk === "";
};
var objToCssArray = function objToCssArray(obj, prevKey) {
    var rules = [];
    var keys = Object.keys(obj);
    keys.forEach(function(key) {
        if (!isFalsish(obj[key])) {
            if (isPlainObject(obj[key])) {
                rules.push.apply(rules, objToCssArray(obj[key], key));
                return rules;
            } else if (isFunction(obj[key])) {
                rules.push(hyphenateStyleName(key) + ":", obj[key], ";");
                return rules;
            }
            rules.push(hyphenateStyleName(key) + ": " + addUnitIfNeeded(key, obj[key]) + ";");
        }
        return rules;
    });
    return prevKey ? [
        prevKey + " {"
    ].concat(rules, [
        "}"
    ]) : rules;
};
function flatten(chunk, executionContext, styleSheet) {
    if (Array.isArray(chunk)) {
        var ruleSet = [];
        for(var i = 0, len = chunk.length, result; i < len; i += 1){
            result = flatten(chunk[i], executionContext, styleSheet);
            if (result === null) continue;
            else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);
            else ruleSet.push(result);
        }
        return ruleSet;
    }
    if (isFalsish(chunk)) return null;
    /* Handle other components */ if (isStyledComponent(chunk)) return "." + chunk.styledComponentId;
    /* Either execute or defer the function */ if (isFunction(chunk)) {
        if (isStatelessFunction(chunk) && executionContext) {
            var _result = chunk(executionContext);
            return flatten(_result, executionContext, styleSheet);
        } else return chunk;
    }
    if (chunk instanceof Keyframes) {
        if (styleSheet) {
            chunk.inject(styleSheet);
            return chunk.getName();
        } else return chunk;
    }
    /* Handle objects */ return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}
// 
function css(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if (isFunction(styles) || isPlainObject(styles)) // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return flatten(interleave(styles, interpolations));
}
// 
function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
    if (!(0, _reactIs.isValidElementType)(tag)) throw new StyledComponentsError(1, String(tag));
    /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
        return componentConstructor(tag, options, css.apply(undefined, arguments));
    };
    /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
        return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    /* Modify/inject new props at runtime */ templateFunction.attrs = function(attrs) {
        return constructWithOptions(componentConstructor, tag, _extends({}, options, {
            attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
        }));
    };
    return templateFunction;
}
// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
    for(var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;)b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
    switch(e){
        case 3:
            a ^= (c.charCodeAt(d + 2) & 255) << 16;
        case 2:
            a ^= (c.charCodeAt(d + 1) & 255) << 8;
        case 1:
            a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
    }
    a ^= a >>> 13;
    a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
    return (a ^ a >>> 15) >>> 0;
}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ function generateAlphabeticName(code) {
    var name = "";
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > charsLength; x = Math.floor(x / charsLength))name = getAlphabeticChar(x % charsLength) + name;
    return getAlphabeticChar(x % charsLength) + name;
}
// 
function hasFunctionObjectKey(obj) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in obj){
        if (isFunction(obj[key])) return true;
    }
    return false;
}
function isStaticRules(rules, attrs) {
    for(var i = 0; i < rules.length; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !isStaticRules(rule, attrs)) return false;
        else if (isFunction(rule) && !isStyledComponent(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs.some(function(x) {
        return isFunction(x) || hasFunctionObjectKey(x);
    })) return false;
    return true;
}
// 
/* combines hashStr (murmurhash) and nameGenerator for convenience */ var hasher = function hasher(str) {
    return generateAlphabeticName(murmurhash(str));
};
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var ComponentStyle = function() {
    function ComponentStyle(rules, attrs, componentId) {
        classCallCheck(this, ComponentStyle);
        this.rules = rules;
        this.isStatic = isStaticRules(rules, attrs);
        this.componentId = componentId;
        if (!StyleSheet.master.hasId(componentId)) StyleSheet.master.deferredInject(componentId, []);
    }
    /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
        var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
        if (IS_BROWSER && isStatic && typeof lastClassName === "string" && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
        var flatCSS = flatten(this.rules, executionContext, styleSheet);
        var name = hasher(this.componentId + flatCSS.join(""));
        if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, stringifyRules(flatCSS, "." + name, undefined, componentId), name);
        this.lastClassName = name;
        return name;
    };
    ComponentStyle.generateName = function generateName(str) {
        return hasher(str);
    };
    return ComponentStyle;
}();
// 
var LIMIT = 200;
var createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn("Over " + LIMIT + " classes were generated for component " + displayName + ". \n" + "Consider using the attrs method, together with a style object for frequently changed styles.\n" + "Example:\n" + "  const Component = styled.div.attrs(props => ({\n" + "    style: {\n" + "      background: props.background,\n" + "    },\n" + "  }))`width: 100%;`\n\n" + "  <Component />");
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var determineTheme = function(props, fallbackTheme) {
    var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types, flowtype-errors/show-errors */ var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
    /* eslint-enable */ return theme;
};
// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function escape(str) {
    return str// Replace all possible CSS selectors
    .replace(escapeRegex, "-")// Remove extraneous hyphens at the start and end
    .replace(dashesAtEnds, "");
}
// 
function isTag(target) {
    return typeof target === "string" && true;
}
// 
function generateDisplayName(target) {
    // $FlowFixMe
    return isTag(target) ? "styled." + target : "Styled(" + getComponentName(target) + ")";
}
var _TYPE_STATICS;
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDerivedStateFromProps: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[0, _reactIs.ForwardRef] = {
    $$typeof: true,
    render: true
}, _TYPE_STATICS);
var defineProperty$1 = Object.defineProperty, getOwnPropertyNames = Object.getOwnPropertyNames, _Object$getOwnPropert = Object.getOwnPropertySymbols, getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function() {
    return [];
} : _Object$getOwnPropert, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getPrototypeOf = Object.getPrototypeOf, objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent), // $FlowFixMe
        getOwnPropertySymbols(sourceComponent));
        var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;
        var i = keys.length;
        var descriptor = void 0;
        var key = void 0;
        // eslint-disable-next-line no-plusplus
        while(i--){
            key = keys[i];
            if (// $FlowFixMe
            !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && // $FlowFixMe
            !(targetStatics && targetStatics[key])) {
                descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                if (descriptor) try {
                    // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {
                /* fail silently */ }
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
// 
function isDerivedReactComponent(fn) {
    return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}
// 
// Helper to call a given function, only once
var once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb.apply(undefined, arguments);
        }
    };
};
// 
var ThemeContext = (0, _react.createContext)();
var ThemeConsumer = ThemeContext.Consumer;
/**
 * Provide a theme to an entire react component tree via context
 */ var ThemeProvider = function(_Component) {
    inherits(ThemeProvider, _Component);
    function ThemeProvider(props) {
        classCallCheck(this, ThemeProvider);
        var _this = possibleConstructorReturn(this, _Component.call(this, props));
        _this.getContext = (0, _memoizeOneDefault.default)(_this.getContext.bind(_this));
        _this.renderInner = _this.renderInner.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, _reactDefault.default).createElement(ThemeContext.Consumer, null, this.renderInner);
    };
    ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
        var context = this.getContext(this.props.theme, outerTheme);
        return (0, _reactDefault.default).createElement(ThemeContext.Provider, {
            value: context
        }, this.props.children);
    };
    /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */ ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
        if (isFunction(theme)) {
            var mergedTheme = theme(outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === "undefined" ? "undefined" : _typeof(theme)) !== "object") throw new StyledComponentsError(8);
        return _extends({}, outerTheme, theme);
    };
    ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
        return this.getTheme(theme, outerTheme);
    };
    return ThemeProvider;
}((0, _react.Component));
// 
var CLOSING_TAG_R = /^\s*<\/[a-z]/i;
var ServerStyleSheet = function() {
    function ServerStyleSheet() {
        classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.sealed = false;
    }
    /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */ ServerStyleSheet.prototype.seal = function seal() {
        if (!this.sealed) {
            /* Remove sealed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.sealed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.sealed) throw new StyledComponentsError(2);
        return (0, _reactDefault.default).createElement(StyleSheetManager, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.seal();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.seal();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var StyleSheetContext = (0, _react.createContext)();
var StyleSheetConsumer = StyleSheetContext.Consumer;
var StyleSheetManager = function(_Component) {
    inherits(StyleSheetManager, _Component);
    function StyleSheetManager(props) {
        classCallCheck(this, StyleSheetManager);
        var _this = possibleConstructorReturn(this, _Component.call(this, props));
        _this.getContext = (0, _memoizeOneDefault.default)(_this.getContext);
        return _this;
    }
    StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
        if (sheet) return sheet;
        else if (target) return new StyleSheet(target);
        else throw new StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        var _props = this.props, children = _props.children, sheet = _props.sheet, target = _props.target;
        return (0, _reactDefault.default).createElement(StyleSheetContext.Provider, {
            value: this.getContext(sheet, target)
        }, children);
    };
    return StyleSheetManager;
}((0, _react.Component));
// 
var identifiers = {};
/* We depend on components having unique IDs */ function generateId(_ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== "string" ? "sc" : escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = (identifiers[displayName] || 0) + 1;
    identifiers[displayName] = nr;
    var componentId = displayName + "-" + _ComponentStyle.generateName(displayName + nr);
    return parentComponentId ? parentComponentId + "-" + componentId : componentId;
}
// $FlowFixMe
var StyledComponent = function(_Component) {
    inherits(StyledComponent, _Component);
    function StyledComponent() {
        classCallCheck(this, StyledComponent);
        var _this = possibleConstructorReturn(this, _Component.call(this));
        _this.attrs = {};
        _this.renderOuter = _this.renderOuter.bind(_this);
        _this.renderInner = _this.renderInner.bind(_this);
        return _this;
    }
    StyledComponent.prototype.render = function render() {
        return (0, _reactDefault.default).createElement(StyleSheetConsumer, null, this.renderOuter);
    };
    StyledComponent.prototype.renderOuter = function renderOuter() {
        var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;
        this.styleSheet = styleSheet;
        // No need to subscribe a static component to theme changes, it won't change anything
        if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();
        return (0, _reactDefault.default).createElement(ThemeConsumer, null, this.renderInner);
    };
    StyledComponent.prototype.renderInner = function renderInner(theme) {
        var _props$forwardedCompo = this.props.forwardedComponent, componentStyle = _props$forwardedCompo.componentStyle, defaultProps = _props$forwardedCompo.defaultProps, displayName = _props$forwardedCompo.displayName, foldedComponentIds = _props$forwardedCompo.foldedComponentIds, styledComponentId = _props$forwardedCompo.styledComponentId, target = _props$forwardedCompo.target;
        var generatedClassName = void 0;
        if (componentStyle.isStatic) generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
        else generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
        var elementToBeCreated = this.props.as || this.attrs.as || target;
        var isTargetTag = isTag(elementToBeCreated);
        var propsForElement = {};
        var computedProps = _extends({}, this.props, this.attrs);
        var key = void 0;
        // eslint-disable-next-line guard-for-in
        for(key in computedProps){
            if (key === "forwardedComponent" || key === "as") continue;
            else if (key === "forwardedRef") propsForElement.ref = computedProps[key];
            else if (key === "forwardedAs") propsForElement.as = computedProps[key];
            else if (!isTargetTag || (0, _isPropValidDefault.default)(key)) // Don't pass through non HTML tags through to HTML elements
            propsForElement[key] = computedProps[key];
        }
        if (this.props.style && this.attrs.style) propsForElement.style = _extends({}, this.attrs.style, this.props.style);
        propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(" ");
        return (0, _react.createElement)(elementToBeCreated, propsForElement);
    };
    StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
        var _this2 = this;
        var context = _extends({}, props, {
            theme: theme
        });
        if (!attrs.length) return context;
        this.attrs = {};
        attrs.forEach(function(attrDef) {
            var resolvedAttrDef = attrDef;
            var attrDefWasFn = false;
            var attr = void 0;
            var key = void 0;
            if (isFunction(resolvedAttrDef)) {
                // $FlowFixMe
                resolvedAttrDef = resolvedAttrDef(context);
                attrDefWasFn = true;
            }
            /* eslint-disable guard-for-in */ // $FlowFixMe
            for(key in resolvedAttrDef){
                attr = resolvedAttrDef[key];
                if (!attrDefWasFn) {
                    if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) attr = attr(context);
                }
                _this2.attrs[key] = attr;
                context[key] = attr;
            }
        /* eslint-enable */ });
        return context;
    };
    StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _props$forwardedCompo2 = props.forwardedComponent, attrs = _props$forwardedCompo2.attrs, componentStyle = _props$forwardedCompo2.componentStyle, warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && !attrs.length) return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
        var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);
        return className;
    };
    return StyledComponent;
}((0, _react.Component));
function createStyledComponent(target, options, rules) {
    var isTargetStyledComp = isStyledComponent(target);
    var isClass = !isTag(target);
    var _options$displayName = options.displayName, displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon, _options$attrs = options.attrs, attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;
    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + "-" + options.componentId : options.componentId || componentId;
    // fold the underlying StyledComponent attrs up (implicit extend)
    var finalAttrs = // $FlowFixMe
    isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;
    var componentStyle = new ComponentStyle(isTargetStyledComp ? // $FlowFixMe
    target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);
    /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */ var WrappedStyledComponent = void 0;
    var forwardRef = function forwardRef(props, ref) {
        return (0, _reactDefault.default).createElement(ParentComponent, _extends({}, props, {
            forwardedComponent: WrappedStyledComponent,
            forwardedRef: ref
        }));
    };
    forwardRef.displayName = displayName;
    WrappedStyledComponent = (0, _reactDefault.default).forwardRef(forwardRef);
    WrappedStyledComponent.displayName = displayName;
    // $FlowFixMe
    WrappedStyledComponent.attrs = finalAttrs;
    // $FlowFixMe
    WrappedStyledComponent.componentStyle = componentStyle;
    // $FlowFixMe
    WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;
    // $FlowFixMe
    WrappedStyledComponent.styledComponentId = styledComponentId;
    // fold the underlying StyledComponent target up since we folded the styles
    // $FlowFixMe
    WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;
    // $FlowFixMe
    WrappedStyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId, optionsToCopy = objectWithoutProperties(options, [
            "componentId"
        ]);
        var newComponentId = previousComponentId && previousComponentId + "-" + (isTag(tag) ? tag : escape(getComponentName(tag)));
        var newOptions = _extends({}, optionsToCopy, {
            attrs: finalAttrs,
            componentId: newComponentId,
            ParentComponent: ParentComponent
        });
        return createStyledComponent(tag, newOptions, rules);
    };
    // $FlowFixMe
    Object.defineProperty(WrappedStyledComponent, "defaultProps", {
        get: function get$$1() {
            return this._foldedDefaultProps;
        },
        set: function set$$1(obj) {
            // $FlowFixMe
            this._foldedDefaultProps = isTargetStyledComp ? (0, _mergeAnythingDefault.default)(target.defaultProps, obj) : obj;
        }
    });
    // $FlowFixMe
    WrappedStyledComponent.toString = function() {
        return "." + WrappedStyledComponent.styledComponentId;
    };
    if (isClass) hoistNonReactStatics(WrappedStyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        foldedComponentIds: true,
        styledComponentId: true,
        target: true,
        withComponent: true
    });
    return WrappedStyledComponent;
}
// 
// Thanks to ReactDOMFactories for this handy list!
var domElements = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
// 
var styled = function styled(tag) {
    return constructWithOptions(createStyledComponent, tag);
};
// Shorthands for all valid HTML Elements
domElements.forEach(function(domElement) {
    styled[domElement] = styled(domElement);
});
// 
var GlobalStyle = function() {
    function GlobalStyle(rules, componentId) {
        classCallCheck(this, GlobalStyle);
        this.rules = rules;
        this.componentId = componentId;
        this.isStatic = isStaticRules(rules, EMPTY_ARRAY);
        if (!StyleSheet.master.hasId(componentId)) StyleSheet.master.deferredInject(componentId, []);
    }
    GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
        var flatCSS = flatten(this.rules, executionContext, styleSheet);
        var css = stringifyRules(flatCSS, "");
        styleSheet.inject(this.componentId, css);
    };
    GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
        var componentId = this.componentId;
        if (styleSheet.hasId(componentId)) styleSheet.remove(componentId);
    };
    // TODO: overwrite in-place instead of remove+create?
    GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
        this.removeStyles(styleSheet);
        this.createStyles(executionContext, styleSheet);
    };
    return GlobalStyle;
}();
// 
// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) window.scCGSHMRCache = {};
function createGlobalStyle(strings) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = css.apply(undefined, [
        strings
    ].concat(interpolations));
    var id = "sc-global-" + murmurhash(JSON.stringify(rules));
    var style = new GlobalStyle(rules, id);
    var GlobalStyleComponent = function(_React$Component) {
        inherits(GlobalStyleComponent, _React$Component);
        function GlobalStyleComponent(props) {
            classCallCheck(this, GlobalStyleComponent);
            var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
            var _this$constructor = _this.constructor, globalStyle = _this$constructor.globalStyle, styledComponentId = _this$constructor.styledComponentId;
            if (IS_BROWSER) window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
            /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */ _this.state = {
                globalStyle: globalStyle,
                styledComponentId: styledComponentId
            };
            return _this;
        }
        GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            if (window.scCGSHMRCache[this.state.styledComponentId]) window.scCGSHMRCache[this.state.styledComponentId] -= 1;
            /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */ if (window.scCGSHMRCache[this.state.styledComponentId] === 0) this.state.globalStyle.removeStyles(this.styleSheet);
        };
        GlobalStyleComponent.prototype.render = function render() {
            var _this2 = this;
            return (0, _reactDefault.default).createElement(StyleSheetConsumer, null, function(styleSheet) {
                _this2.styleSheet = styleSheet || StyleSheet.master;
                var globalStyle = _this2.state.globalStyle;
                if (globalStyle.isStatic) {
                    globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);
                    return null;
                } else return (0, _reactDefault.default).createElement(ThemeConsumer, null, function(theme) {
                    // $FlowFixMe
                    var defaultProps = _this2.constructor.defaultProps;
                    var context = _extends({}, _this2.props);
                    if (typeof theme !== "undefined") context.theme = determineTheme(_this2.props, theme, defaultProps);
                    globalStyle.renderStyles(context, _this2.styleSheet);
                    return null;
                });
            });
        };
        return GlobalStyleComponent;
    }((0, _reactDefault.default).Component);
    GlobalStyleComponent.globalStyle = style;
    GlobalStyleComponent.styledComponentId = id;
    return GlobalStyleComponent;
}
// 
var replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, "");
};
function keyframes(strings) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = css.apply(undefined, [
        strings
    ].concat(interpolations));
    var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    return new Keyframes(name, stringifyRules(rules, name, "@keyframes"));
}
// 
var withTheme = function(Component$$1) {
    var WithTheme = (0, _reactDefault.default).forwardRef(function(props, ref) {
        return (0, _reactDefault.default).createElement(ThemeConsumer, null, function(theme) {
            // $FlowFixMe
            var defaultProps = Component$$1.defaultProps;
            var themeProp = determineTheme(props, theme, defaultProps);
            return (0, _reactDefault.default).createElement(Component$$1, _extends({}, props, {
                theme: themeProp,
                ref: ref
            }));
        });
    });
    hoistNonReactStatics(WithTheme, Component$$1);
    WithTheme.displayName = "WithTheme(" + getComponentName(Component$$1) + ")";
    return WithTheme;
};
// 
/* eslint-disable */ var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
    StyleSheet: StyleSheet
};
//
exports.default = styled;

},{"50571207bc3cae02":"5QIF0","stylis/stylis.min":"i1lSg","stylis-rule-sheet":"9XSvM","react":"6uln9","@emotion/unitless":"1Dclg","react-is":"aUAsc","memoize-one":"9ZyRf","prop-types":"6FKs7","@emotion/is-prop-valid":"9l1v9","merge-anything":"jOpK9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5QIF0":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"i1lSg":[function(require,module,exports) {
!function(e) {
    module.exports = e(null);
}(function e(a) {
    "use strict";
    var r = /^\0+/g, c = /[\0\r\f]/g, s = /: */g, t = /zoo|gra/, i = /([,: ])(transform)/g, f = /,+\s*(?![^(]*[)])/g, n = / +\s*(?![^(]*[)])/g, l = / *[\0] */g, o = /,\r+?/g, h = /([\t\r\n ])*\f?&/g, u = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g, d = /\W+/g, b = /@(k\w+)\s*(\S*)\s*/, p = /::(place)/g, k = /:(read-only)/g, g = /\s+(?=[{\];=:>])/g, A = /([[}=:>])\s+/g, C = /(\{[^{]+?);(?=\})/g, w = /\s{2,}/g, v = /([^\(])(:+) */g, m = /[svh]\w+-[tblr]{2}/, x = /\(\s*(.*)\s*\)/g, $ = /([\s\S]*?);/g, y = /-self|flex-/g, O = /[^]*?(:[rp][el]a[\w-]+)[^]*/, j = /stretch|:\s*\w+\-(?:conte|avail)/, z = /([^-])(image-set\()/, N = "-webkit-", S = "-moz-", F = "-ms-", W = 59, q = 125, B = 123, D = 40, E = 41, G = 91, H = 93, I = 10, J = 13, K = 9, L = 64, M = 32, P = 38, Q = 45, R = 95, T = 42, U = 44, V = 58, X = 39, Y = 34, Z = 47, _ = 62, ee = 43, ae = 126, re = 0, ce = 12, se = 11, te = 107, ie = 109, fe = 115, ne = 112, le = 111, oe = 105, he = 99, ue = 100, de = 112, be = 1, pe = 1, ke = 0, ge = 1, Ae = 1, Ce = 1, we = 0, ve = 0, me = 0, xe = [], $e = [], ye = 0, Oe = null, je = -2, ze = -1, Ne = 0, Se = 1, Fe = 2, We = 3, qe = 0, Be = 1, De = "", Ee = "", Ge = "";
    function He(e, a, s, t, i) {
        for(var f, n, o = 0, h = 0, u = 0, d = 0, g = 0, A = 0, C = 0, w = 0, m = 0, $ = 0, y = 0, O = 0, j = 0, z = 0, R = 0, we = 0, $e = 0, Oe = 0, je = 0, ze = s.length, Je = ze - 1, Re = "", Te = "", Ue = "", Ve = "", Xe = "", Ye = ""; R < ze;){
            if (C = s.charCodeAt(R), R === Je) {
                if (h + d + u + o !== 0) {
                    if (0 !== h) C = h === Z ? I : Z;
                    d = u = o = 0, ze++, Je++;
                }
            }
            if (h + d + u + o === 0) {
                if (R === Je) {
                    if (we > 0) Te = Te.replace(c, "");
                    if (Te.trim().length > 0) {
                        switch(C){
                            case M:
                            case K:
                            case W:
                            case J:
                            case I:
                                break;
                            default:
                                Te += s.charAt(R);
                        }
                        C = W;
                    }
                }
                if (1 === $e) switch(C){
                    case B:
                    case q:
                    case W:
                    case Y:
                    case X:
                    case D:
                    case E:
                    case U:
                        $e = 0;
                    case K:
                    case J:
                    case I:
                    case M:
                        break;
                    default:
                        for($e = 0, je = R, g = C, R--, C = W; je < ze;)switch(s.charCodeAt(je++)){
                            case I:
                            case J:
                            case W:
                                ++R, C = g, je = ze;
                                break;
                            case V:
                                if (we > 0) ++R, C = g;
                            case B:
                                je = ze;
                        }
                }
                switch(C){
                    case B:
                        for(g = (Te = Te.trim()).charCodeAt(0), y = 1, je = ++R; R < ze;){
                            switch(C = s.charCodeAt(R)){
                                case B:
                                    y++;
                                    break;
                                case q:
                                    y--;
                                    break;
                                case Z:
                                    switch(A = s.charCodeAt(R + 1)){
                                        case T:
                                        case Z:
                                            R = Qe(A, R, Je, s);
                                    }
                                    break;
                                case G:
                                    C++;
                                case D:
                                    C++;
                                case Y:
                                case X:
                                    for(; R++ < Je && s.charCodeAt(R) !== C;);
                            }
                            if (0 === y) break;
                            R++;
                        }
                        if (Ue = s.substring(je, R), g === re) g = (Te = Te.replace(r, "").trim()).charCodeAt(0);
                        switch(g){
                            case L:
                                if (we > 0) Te = Te.replace(c, "");
                                switch(A = Te.charCodeAt(1)){
                                    case ue:
                                    case ie:
                                    case fe:
                                    case Q:
                                        f = a;
                                        break;
                                    default:
                                        f = xe;
                                }
                                if (je = (Ue = He(a, f, Ue, A, i + 1)).length, me > 0 && 0 === je) je = Te.length;
                                if (ye > 0) {
                                    if (f = Ie(xe, Te, Oe), n = Pe(We, Ue, f, a, pe, be, je, A, i, t), Te = f.join(""), void 0 !== n) {
                                        if (0 === (je = (Ue = n.trim()).length)) A = 0, Ue = "";
                                    }
                                }
                                if (je > 0) switch(A){
                                    case fe:
                                        Te = Te.replace(x, Me);
                                    case ue:
                                    case ie:
                                    case Q:
                                        Ue = Te + "{" + Ue + "}";
                                        break;
                                    case te:
                                        if (Ue = (Te = Te.replace(b, "$1 $2" + (Be > 0 ? De : ""))) + "{" + Ue + "}", 1 === Ae || 2 === Ae && Le("@" + Ue, 3)) Ue = "@" + N + Ue + "@" + Ue;
                                        else Ue = "@" + Ue;
                                        break;
                                    default:
                                        if (Ue = Te + Ue, t === de) Ve += Ue, Ue = "";
                                }
                                else Ue = "";
                                break;
                            default:
                                Ue = He(a, Ie(a, Te, Oe), Ue, t, i + 1);
                        }
                        Xe += Ue, O = 0, $e = 0, z = 0, we = 0, Oe = 0, j = 0, Te = "", Ue = "", C = s.charCodeAt(++R);
                        break;
                    case q:
                    case W:
                        if ((je = (Te = (we > 0 ? Te.replace(c, "") : Te).trim()).length) > 1) {
                            if (0 === z) {
                                if ((g = Te.charCodeAt(0)) === Q || g > 96 && g < 123) je = (Te = Te.replace(" ", ":")).length;
                            }
                            if (ye > 0) {
                                if (void 0 !== (n = Pe(Se, Te, a, e, pe, be, Ve.length, t, i, t))) {
                                    if (0 === (je = (Te = n.trim()).length)) Te = "\x00\x00";
                                }
                            }
                            switch(g = Te.charCodeAt(0), A = Te.charCodeAt(1), g){
                                case re:
                                    break;
                                case L:
                                    if (A === oe || A === he) {
                                        Ye += Te + s.charAt(R);
                                        break;
                                    }
                                default:
                                    if (Te.charCodeAt(je - 1) === V) break;
                                    Ve += Ke(Te, g, A, Te.charCodeAt(2));
                            }
                        }
                        O = 0, $e = 0, z = 0, we = 0, Oe = 0, Te = "", C = s.charCodeAt(++R);
                }
            }
            switch(C){
                case J:
                case I:
                    if (h + d + u + o + ve === 0) switch($){
                        case E:
                        case X:
                        case Y:
                        case L:
                        case ae:
                        case _:
                        case T:
                        case ee:
                        case Z:
                        case Q:
                        case V:
                        case U:
                        case W:
                        case B:
                        case q:
                            break;
                        default:
                            if (z > 0) $e = 1;
                    }
                    if (h === Z) h = 0;
                    else if (ge + O === 0 && t !== te && Te.length > 0) we = 1, Te += "\x00";
                    if (ye * qe > 0) Pe(Ne, Te, a, e, pe, be, Ve.length, t, i, t);
                    be = 1, pe++;
                    break;
                case W:
                case q:
                    if (h + d + u + o === 0) {
                        be++;
                        break;
                    }
                default:
                    switch(be++, Re = s.charAt(R), C){
                        case K:
                        case M:
                            if (d + o + h === 0) switch(w){
                                case U:
                                case V:
                                case K:
                                case M:
                                    Re = "";
                                    break;
                                default:
                                    if (C !== M) Re = " ";
                            }
                            break;
                        case re:
                            Re = "\\0";
                            break;
                        case ce:
                            Re = "\\f";
                            break;
                        case se:
                            Re = "\\v";
                            break;
                        case P:
                            if (d + h + o === 0 && ge > 0) Oe = 1, we = 1, Re = "\f" + Re;
                            break;
                        case 108:
                            if (d + h + o + ke === 0 && z > 0) switch(R - z){
                                case 2:
                                    if (w === ne && s.charCodeAt(R - 3) === V) ke = w;
                                case 8:
                                    if (m === le) ke = m;
                            }
                            break;
                        case V:
                            if (d + h + o === 0) z = R;
                            break;
                        case U:
                            if (h + u + d + o === 0) we = 1, Re += "\r";
                            break;
                        case Y:
                        case X:
                            if (0 === h) d = d === C ? 0 : 0 === d ? C : d;
                            break;
                        case G:
                            if (d + h + u === 0) o++;
                            break;
                        case H:
                            if (d + h + u === 0) o--;
                            break;
                        case E:
                            if (d + h + o === 0) u--;
                            break;
                        case D:
                            if (d + h + o === 0) {
                                if (0 === O) switch(2 * w + 3 * m){
                                    case 533:
                                        break;
                                    default:
                                        y = 0, O = 1;
                                }
                                u++;
                            }
                            break;
                        case L:
                            if (h + u + d + o + z + j === 0) j = 1;
                            break;
                        case T:
                        case Z:
                            if (d + o + u > 0) break;
                            switch(h){
                                case 0:
                                    switch(2 * C + 3 * s.charCodeAt(R + 1)){
                                        case 235:
                                            h = Z;
                                            break;
                                        case 220:
                                            je = R, h = T;
                                    }
                                    break;
                                case T:
                                    if (C === Z && w === T && je + 2 !== R) {
                                        if (33 === s.charCodeAt(je + 2)) Ve += s.substring(je, R + 1);
                                        Re = "", h = 0;
                                    }
                            }
                    }
                    if (0 === h) {
                        if (ge + d + o + j === 0 && t !== te && C !== W) switch(C){
                            case U:
                            case ae:
                            case _:
                            case ee:
                            case E:
                            case D:
                                if (0 === O) {
                                    switch(w){
                                        case K:
                                        case M:
                                        case I:
                                        case J:
                                            Re += "\x00";
                                            break;
                                        default:
                                            Re = "\x00" + Re + (C === U ? "" : "\x00");
                                    }
                                    we = 1;
                                } else switch(C){
                                    case D:
                                        if (z + 7 === R && 108 === w) z = 0;
                                        O = ++y;
                                        break;
                                    case E:
                                        if (0 == (O = --y)) we = 1, Re += "\x00";
                                }
                                break;
                            case K:
                            case M:
                                switch(w){
                                    case re:
                                    case B:
                                    case q:
                                    case W:
                                    case U:
                                    case ce:
                                    case K:
                                    case M:
                                    case I:
                                    case J:
                                        break;
                                    default:
                                        if (0 === O) we = 1, Re += "\x00";
                                }
                        }
                        if (Te += Re, C !== M && C !== K) $ = C;
                    }
            }
            m = w, w = C, R++;
        }
        if (je = Ve.length, me > 0) {
            if (0 === je && 0 === Xe.length && 0 === a[0].length == false) {
                if (t !== ie || 1 === a.length && (ge > 0 ? Ee : Ge) === a[0]) je = a.join(",").length + 2;
            }
        }
        if (je > 0) {
            if (f = 0 === ge && t !== te ? function(e) {
                for(var a, r, s = 0, t = e.length, i = Array(t); s < t; ++s){
                    for(var f = e[s].split(l), n = "", o = 0, h = 0, u = 0, d = 0, b = f.length; o < b; ++o){
                        if (0 === (h = (r = f[o]).length) && b > 1) continue;
                        if (u = n.charCodeAt(n.length - 1), d = r.charCodeAt(0), a = "", 0 !== o) switch(u){
                            case T:
                            case ae:
                            case _:
                            case ee:
                            case M:
                            case D:
                                break;
                            default:
                                a = " ";
                        }
                        switch(d){
                            case P:
                                r = a + Ee;
                            case ae:
                            case _:
                            case ee:
                            case M:
                            case E:
                            case D:
                                break;
                            case G:
                                r = a + r + Ee;
                                break;
                            case V:
                                switch(2 * r.charCodeAt(1) + 3 * r.charCodeAt(2)){
                                    case 530:
                                        if (Ce > 0) {
                                            r = a + r.substring(8, h - 1);
                                            break;
                                        }
                                    default:
                                        if (o < 1 || f[o - 1].length < 1) r = a + Ee + r;
                                }
                                break;
                            case U:
                                a = "";
                            default:
                                if (h > 1 && r.indexOf(":") > 0) r = a + r.replace(v, "$1" + Ee + "$2");
                                else r = a + r + Ee;
                        }
                        n += r;
                    }
                    i[s] = n.replace(c, "").trim();
                }
                return i;
            }(a) : a, ye > 0) {
                if (void 0 !== (n = Pe(Fe, Ve, f, e, pe, be, je, t, i, t)) && 0 === (Ve = n).length) return Ye + Ve + Xe;
            }
            if (Ve = f.join(",") + "{" + Ve + "}", Ae * ke != 0) {
                if (2 === Ae && !Le(Ve, 2)) ke = 0;
                switch(ke){
                    case le:
                        Ve = Ve.replace(k, ":" + S + "$1") + Ve;
                        break;
                    case ne:
                        Ve = Ve.replace(p, "::" + N + "input-$1") + Ve.replace(p, "::" + S + "$1") + Ve.replace(p, ":" + F + "input-$1") + Ve;
                }
                ke = 0;
            }
        }
        return Ye + Ve + Xe;
    }
    function Ie(e, a, r) {
        var c = a.trim().split(o), s = c, t = c.length, i = e.length;
        switch(i){
            case 0:
            case 1:
                for(var f = 0, n = 0 === i ? "" : e[0] + " "; f < t; ++f)s[f] = Je(n, s[f], r, i).trim();
                break;
            default:
                f = 0;
                var l = 0;
                for(s = []; f < t; ++f)for(var h = 0; h < i; ++h)s[l++] = Je(e[h] + " ", c[f], r, i).trim();
        }
        return s;
    }
    function Je(e, a, r, c) {
        var s = a, t = s.charCodeAt(0);
        if (t < 33) t = (s = s.trim()).charCodeAt(0);
        switch(t){
            case P:
                switch(ge + c){
                    case 0:
                    case 1:
                        if (0 === e.trim().length) break;
                    default:
                        return s.replace(h, "$1" + e.trim());
                }
                break;
            case V:
                switch(s.charCodeAt(1)){
                    case 103:
                        if (Ce > 0 && ge > 0) return s.replace(u, "$1").replace(h, "$1" + Ge);
                        break;
                    default:
                        return e.trim() + s.replace(h, "$1" + e.trim());
                }
            default:
                if (r * ge > 0 && s.indexOf("\f") > 0) return s.replace(h, (e.charCodeAt(0) === V ? "" : "$1") + e.trim());
        }
        return e + s;
    }
    function Ke(e, a, r, c) {
        var l, o = 0, h = e + ";", u = 2 * a + 3 * r + 4 * c;
        if (944 === u) return function(e) {
            var a = e.length, r = e.indexOf(":", 9) + 1, c = e.substring(0, r).trim(), s = e.substring(r, a - 1).trim();
            switch(e.charCodeAt(9) * Be){
                case 0:
                    break;
                case Q:
                    if (110 !== e.charCodeAt(10)) break;
                default:
                    for(var t = s.split((s = "", f)), i = 0, r = 0, a = t.length; i < a; r = 0, ++i){
                        for(var l = t[i], o = l.split(n); l = o[r];){
                            var h = l.charCodeAt(0);
                            if (1 === Be && (h > L && h < 90 || h > 96 && h < 123 || h === R || h === Q && l.charCodeAt(1) !== Q)) switch(isNaN(parseFloat(l)) + (-1 !== l.indexOf("("))){
                                case 1:
                                    switch(l){
                                        case "infinite":
                                        case "alternate":
                                        case "backwards":
                                        case "running":
                                        case "normal":
                                        case "forwards":
                                        case "both":
                                        case "none":
                                        case "linear":
                                        case "ease":
                                        case "ease-in":
                                        case "ease-out":
                                        case "ease-in-out":
                                        case "paused":
                                        case "reverse":
                                        case "alternate-reverse":
                                        case "inherit":
                                        case "initial":
                                        case "unset":
                                        case "step-start":
                                        case "step-end":
                                            break;
                                        default:
                                            l += De;
                                    }
                            }
                            o[r++] = l;
                        }
                        s += (0 === i ? "" : ",") + o.join(" ");
                    }
            }
            if (s = c + s + ";", 1 === Ae || 2 === Ae && Le(s, 1)) return N + s + s;
            return s;
        }(h);
        else if (0 === Ae || 2 === Ae && !Le(h, 1)) return h;
        switch(u){
            case 1015:
                return 97 === h.charCodeAt(10) ? N + h + h : h;
            case 951:
                return 116 === h.charCodeAt(3) ? N + h + h : h;
            case 963:
                return 110 === h.charCodeAt(5) ? N + h + h : h;
            case 1009:
                if (100 !== h.charCodeAt(4)) break;
            case 969:
            case 942:
                return N + h + h;
            case 978:
                return N + h + S + h + h;
            case 1019:
            case 983:
                return N + h + S + h + F + h + h;
            case 883:
                if (h.charCodeAt(8) === Q) return N + h + h;
                if (h.indexOf("image-set(", 11) > 0) return h.replace(z, "$1" + N + "$2") + h;
                return h;
            case 932:
                if (h.charCodeAt(4) === Q) switch(h.charCodeAt(5)){
                    case 103:
                        return N + "box-" + h.replace("-grow", "") + N + h + F + h.replace("grow", "positive") + h;
                    case 115:
                        return N + h + F + h.replace("shrink", "negative") + h;
                    case 98:
                        return N + h + F + h.replace("basis", "preferred-size") + h;
                }
                return N + h + F + h + h;
            case 964:
                return N + h + F + "flex-" + h + h;
            case 1023:
                if (99 !== h.charCodeAt(8)) break;
                return l = h.substring(h.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), N + "box-pack" + l + N + h + F + "flex-pack" + l + h;
            case 1005:
                return t.test(h) ? h.replace(s, ":" + N) + h.replace(s, ":" + S) + h : h;
            case 1e3:
                switch(o = (l = h.substring(13).trim()).indexOf("-") + 1, l.charCodeAt(0) + l.charCodeAt(o)){
                    case 226:
                        l = h.replace(m, "tb");
                        break;
                    case 232:
                        l = h.replace(m, "tb-rl");
                        break;
                    case 220:
                        l = h.replace(m, "lr");
                        break;
                    default:
                        return h;
                }
                return N + h + F + l + h;
            case 1017:
                if (-1 === h.indexOf("sticky", 9)) return h;
            case 975:
                switch(o = (h = e).length - 10, u = (l = (33 === h.charCodeAt(o) ? h.substring(0, o) : h).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | l.charCodeAt(7))){
                    case 203:
                        if (l.charCodeAt(8) < 111) break;
                    case 115:
                        h = h.replace(l, N + l) + ";" + h;
                        break;
                    case 207:
                    case 102:
                        h = h.replace(l, N + (u > 102 ? "inline-" : "") + "box") + ";" + h.replace(l, N + l) + ";" + h.replace(l, F + l + "box") + ";" + h;
                }
                return h + ";";
            case 938:
                if (h.charCodeAt(5) === Q) switch(h.charCodeAt(6)){
                    case 105:
                        return l = h.replace("-items", ""), N + h + N + "box-" + l + F + "flex-" + l + h;
                    case 115:
                        return N + h + F + "flex-item-" + h.replace(y, "") + h;
                    default:
                        return N + h + F + "flex-line-pack" + h.replace("align-content", "").replace(y, "") + h;
                }
                break;
            case 973:
            case 989:
                if (h.charCodeAt(3) !== Q || 122 === h.charCodeAt(4)) break;
            case 931:
            case 953:
                if (true === j.test(e)) {
                    if (115 === (l = e.substring(e.indexOf(":") + 1)).charCodeAt(0)) return Ke(e.replace("stretch", "fill-available"), a, r, c).replace(":fill-available", ":stretch");
                    else return h.replace(l, N + l) + h.replace(l, S + l.replace("fill-", "")) + h;
                }
                break;
            case 962:
                if (h = N + h + (102 === h.charCodeAt(5) ? F + h : "") + h, r + c === 211 && 105 === h.charCodeAt(13) && h.indexOf("transform", 10) > 0) return h.substring(0, h.indexOf(";", 27) + 1).replace(i, "$1" + N + "$2") + h;
        }
        return h;
    }
    function Le(e, a) {
        var r = e.indexOf(1 === a ? ":" : "{"), c = e.substring(0, 3 !== a ? r : 10), s = e.substring(r + 1, e.length - 1);
        return Oe(2 !== a ? c : c.replace(O, "$1"), s, a);
    }
    function Me(e, a) {
        var r = Ke(a, a.charCodeAt(0), a.charCodeAt(1), a.charCodeAt(2));
        return r !== a + ";" ? r.replace($, " or ($1)").substring(4) : "(" + a + ")";
    }
    function Pe(e, a, r, c, s, t, i, f, n, l) {
        for(var o, h = 0, u = a; h < ye; ++h)switch(o = $e[h].call(Te, e, u, r, c, s, t, i, f, n, l)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                u = o;
        }
        if (u !== a) return u;
    }
    function Qe(e, a, r, c) {
        for(var s = a + 1; s < r; ++s)switch(c.charCodeAt(s)){
            case Z:
                if (e === T) {
                    if (c.charCodeAt(s - 1) === T && a + 2 !== s) return s + 1;
                }
                break;
            case I:
                if (e === Z) return s + 1;
        }
        return s;
    }
    function Re(e) {
        for(var a in e){
            var r = e[a];
            switch(a){
                case "keyframe":
                    Be = 0 | r;
                    break;
                case "global":
                    Ce = 0 | r;
                    break;
                case "cascade":
                    ge = 0 | r;
                    break;
                case "compress":
                    we = 0 | r;
                    break;
                case "semicolon":
                    ve = 0 | r;
                    break;
                case "preserve":
                    me = 0 | r;
                    break;
                case "prefix":
                    if (Oe = null, !r) Ae = 0;
                    else if ("function" != typeof r) Ae = 1;
                    else Ae = 2, Oe = r;
            }
        }
        return Re;
    }
    function Te(a, r) {
        if (void 0 !== this && this.constructor === Te) return e(a);
        var s = a, t = s.charCodeAt(0);
        if (t < 33) t = (s = s.trim()).charCodeAt(0);
        if (Be > 0) De = s.replace(d, t === G ? "" : "-");
        if (t = 1, 1 === ge) Ge = s;
        else Ee = s;
        var i, f = [
            Ge
        ];
        if (ye > 0) {
            if (void 0 !== (i = Pe(ze, r, f, f, pe, be, 0, 0, 0, 0)) && "string" == typeof i) r = i;
        }
        var n = He(xe, f, r, 0, 0);
        if (ye > 0) {
            if (void 0 !== (i = Pe(je, n, f, f, pe, be, n.length, 0, 0, 0)) && "string" != typeof (n = i)) t = 0;
        }
        return De = "", Ge = "", Ee = "", ke = 0, pe = 1, be = 1, we * t == 0 ? n : n.replace(c, "").replace(g, "").replace(A, "$1").replace(C, "$1").replace(w, " ");
    }
    if (Te.use = function e(a) {
        switch(a){
            case void 0:
            case null:
                ye = $e.length = 0;
                break;
            default:
                if ("function" == typeof a) $e[ye++] = a;
                else if ("object" == typeof a) for(var r = 0, c = a.length; r < c; ++r)e(a[r]);
                else qe = 0 | !!a;
        }
        return e;
    }, Te.set = Re, void 0 !== a) Re(a);
    return Te;
});

},{}],"9XSvM":[function(require,module,exports) {
(function(factory) {
    module["exports"] = factory();
})(function() {
    "use strict";
    return function(insertRule) {
        var delimiter = "/*|*/";
        var needle = delimiter + "}";
        function toSheet(block) {
            if (block) try {
                insertRule(block + "}");
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ";"), "";
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), "";
                        default:
                            return content + (at === 0 ? delimiter : "");
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

},{}],"1Dclg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"aUAsc":[function(require,module,exports) {
"use strict";
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"1Qg5l"}],"1Qg5l":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"9ZyRf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
exports.default = memoizeOne;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6FKs7":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"7ziwC"}],"7ziwC":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"4Cml4"}],"4Cml4":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"9l1v9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var index = (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
exports.default = index;

},{"@emotion/memoize":"jVYRE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jVYRE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
exports.default = memoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOpK9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatArrays", ()=>concatArrays);
parcelHelpers.export(exports, "merge", ()=>merge);
var _isWhat = require("is-what");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!(0, _isWhat.isPlainObject)(newComer)) {
        // extend merge rules
        if (extensions && (0, _isWhat.isArray)(extensions)) extensions.forEach(function(extend) {
            newComer = extend(origin, newComer);
        });
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if ((0, _isWhat.isPlainObject)(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = __spreadArrays(props_1, symbols_1).reduce(function(carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if (!(0, _isWhat.isSymbol)(key) && !Object.getOwnPropertyNames(newComer).includes(key) || (0, _isWhat.isSymbol)(key) && !Object.getOwnPropertySymbols(newComer).includes(key)) assignProp(carry, key, targetVal, origin);
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = __spreadArrays(props, symbols).reduce(function(carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (0, _isWhat.isPlainObject)(origin) ? origin[key] : undefined;
        // extend merge rules
        if (extensions && (0, _isWhat.isArray)(extensions)) extensions.forEach(function(extend) {
            newVal = extend(targetVal, newVal);
        });
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && (0, _isWhat.isPlainObject)(newVal)) newVal = mergeRecursively(targetVal, newVal, extensions);
        assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */ function merge(origin) {
    var newComers = [];
    for(var _i = 1; _i < arguments.length; _i++)newComers[_i - 1] = arguments[_i];
    var extensions = null;
    var base = origin;
    if ((0, _isWhat.isPlainObject)(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function(result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}
function concatArrays(originVal, newVal) {
    if ((0, _isWhat.isArray)(originVal) && (0, _isWhat.isArray)(newVal)) // concat logic
    return originVal.concat(newVal);
    return newVal; // always return newVal as fallback!!
}
exports.default = merge;

},{"is-what":"2uVyU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2uVyU":[function(require,module,exports) {
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "isAnyObject", ()=>isAnyObject);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBlob", ()=>isBlob);
parcelHelpers.export(exports, "isBoolean", ()=>isBoolean);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isEmptyArray", ()=>isEmptyArray);
parcelHelpers.export(exports, "isEmptyObject", ()=>isEmptyObject);
parcelHelpers.export(exports, "isEmptyString", ()=>isEmptyString);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "isFile", ()=>isFile);
parcelHelpers.export(exports, "isFullArray", ()=>isFullArray);
parcelHelpers.export(exports, "isFullObject", ()=>isFullObject);
parcelHelpers.export(exports, "isFullString", ()=>isFullString);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isMap", ()=>isMap);
parcelHelpers.export(exports, "isNaNValue", ()=>isNaNValue);
parcelHelpers.export(exports, "isNull", ()=>isNull);
parcelHelpers.export(exports, "isNullOrUndefined", ()=>isNullOrUndefined);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isObjectLike", ()=>isObjectLike);
parcelHelpers.export(exports, "isOneOf", ()=>isOneOf);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPrimitive", ()=>isPrimitive);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isSet", ()=>isSet);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isSymbol", ()=>isSymbol);
parcelHelpers.export(exports, "isType", ()=>isType);
parcelHelpers.export(exports, "isUndefined", ()=>isUndefined);
parcelHelpers.export(exports, "isWeakMap", ()=>isWeakMap);
parcelHelpers.export(exports, "isWeakSet", ()=>isWeakSet);
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */ function isUndefined(payload) {
    return getType(payload) === "Undefined";
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */ function isNull(payload) {
    return getType(payload) === "Null";
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function isPlainObject(payload) {
    if (getType(payload) !== "Object") return false;
    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function isObject(payload) {
    return isPlainObject(payload);
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is { [K in any]: never }}
 */ function isEmptyObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length === 0;
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function isFullObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length > 0;
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function isAnyObject(payload) {
    return getType(payload) === "Object";
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */ function isObjectLike(payload) {
    return isAnyObject(payload);
}
/**
 * Returns whether the payload is a function (regular or async)
 *
 * @param {*} payload
 * @returns {payload is AnyFunction}
 */ function isFunction(payload) {
    return typeof payload === "function";
}
/**
 * Returns whether the payload is an array
 *
 * @param {any} payload
 * @returns {payload is any[]}
 */ function isArray(payload) {
    return getType(payload) === "Array";
}
/**
 * Returns whether the payload is a an array with at least 1 item
 *
 * @param {*} payload
 * @returns {payload is any[]}
 */ function isFullArray(payload) {
    return isArray(payload) && payload.length > 0;
}
/**
 * Returns whether the payload is a an empty array
 *
 * @param {*} payload
 * @returns {payload is []}
 */ function isEmptyArray(payload) {
    return isArray(payload) && payload.length === 0;
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */ function isString(payload) {
    return getType(payload) === "String";
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */ function isFullString(payload) {
    return isString(payload) && payload !== "";
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */ function isEmptyString(payload) {
    return payload === "";
}
/**
 * Returns whether the payload is a number (but not NaN)
 *
 * This will return `false` for `NaN`!!
 *
 * @param {*} payload
 * @returns {payload is number}
 */ function isNumber(payload) {
    return getType(payload) === "Number" && !isNaN(payload);
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */ function isBoolean(payload) {
    return getType(payload) === "Boolean";
}
/**
 * Returns whether the payload is a regular expression (RegExp)
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */ function isRegExp(payload) {
    return getType(payload) === "RegExp";
}
/**
 * Returns whether the payload is a Map
 *
 * @param {*} payload
 * @returns {payload is Map<any, any>}
 */ function isMap(payload) {
    return getType(payload) === "Map";
}
/**
 * Returns whether the payload is a WeakMap
 *
 * @param {*} payload
 * @returns {payload is WeakMap<any, any>}
 */ function isWeakMap(payload) {
    return getType(payload) === "WeakMap";
}
/**
 * Returns whether the payload is a Set
 *
 * @param {*} payload
 * @returns {payload is Set<any>}
 */ function isSet(payload) {
    return getType(payload) === "Set";
}
/**
 * Returns whether the payload is a WeakSet
 *
 * @param {*} payload
 * @returns {payload is WeakSet<any>}
 */ function isWeakSet(payload) {
    return getType(payload) === "WeakSet";
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is symbol}
 */ function isSymbol(payload) {
    return getType(payload) === "Symbol";
}
/**
 * Returns whether the payload is a Date, and that the date is valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */ function isDate(payload) {
    return getType(payload) === "Date" && !isNaN(payload);
}
/**
 * Returns whether the payload is a Blob
 *
 * @param {*} payload
 * @returns {payload is Blob}
 */ function isBlob(payload) {
    return getType(payload) === "Blob";
}
/**
 * Returns whether the payload is a File
 *
 * @param {*} payload
 * @returns {payload is File}
 */ function isFile(payload) {
    return getType(payload) === "File";
}
/**
 * Returns whether the payload is a Promise
 *
 * @param {*} payload
 * @returns {payload is Promise<any>}
 */ function isPromise(payload) {
    return getType(payload) === "Promise";
}
/**
 * Returns whether the payload is an Error
 *
 * @param {*} payload
 * @returns {payload is Error}
 */ function isError(payload) {
    return getType(payload) === "Error";
}
/**
 * Returns whether the payload is literally the value `NaN` (it's `NaN` and also a `number`)
 *
 * @param {*} payload
 * @returns {payload is typeof NaN}
 */ function isNaNValue(payload) {
    return getType(payload) === "Number" && isNaN(payload);
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
 */ function isPrimitive(payload) {
    return isBoolean(payload) || isNull(payload) || isUndefined(payload) || isNumber(payload) || isString(payload) || isSymbol(payload);
}
/**
 * Returns true whether the payload is null or undefined
 *
 * @param {*} payload
 * @returns {(payload is null | undefined)}
 */ var isNullOrUndefined = isOneOf(isNull, isUndefined);
function isOneOf(a, b, c, d, e) {
    return function(value) {
        return a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
    };
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */ function isType(payload, type) {
    if (!(type instanceof Function)) throw new TypeError("Type must be a function");
    if (!Object.prototype.hasOwnProperty.call(type, "prototype")) throw new TypeError("Type is not a class");
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return getType(payload) === name || Boolean(payload && payload.constructor === type);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4at9Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>(0, _portalJs.Portal));
var _clientOnly = require("client-only");
var _comboboxJs = require("./components/combobox/combobox.js");
parcelHelpers.exportAll(_comboboxJs, exports);
var _dialogJs = require("./components/dialog/dialog.js");
parcelHelpers.exportAll(_dialogJs, exports);
var _disclosureJs = require("./components/disclosure/disclosure.js");
parcelHelpers.exportAll(_disclosureJs, exports);
var _focusTrapJs = require("./components/focus-trap/focus-trap.js");
parcelHelpers.exportAll(_focusTrapJs, exports);
var _listboxJs = require("./components/listbox/listbox.js");
parcelHelpers.exportAll(_listboxJs, exports);
var _menuJs = require("./components/menu/menu.js");
parcelHelpers.exportAll(_menuJs, exports);
var _popoverJs = require("./components/popover/popover.js");
parcelHelpers.exportAll(_popoverJs, exports);
var _radioGroupJs = require("./components/radio-group/radio-group.js");
parcelHelpers.exportAll(_radioGroupJs, exports);
var _switchJs = require("./components/switch/switch.js");
parcelHelpers.exportAll(_switchJs, exports);
var _tabsJs = require("./components/tabs/tabs.js");
parcelHelpers.exportAll(_tabsJs, exports);
var _transitionJs = require("./components/transitions/transition.js");
parcelHelpers.exportAll(_transitionJs, exports);
var _portalJs = require("./components/portal/portal.js");

},{"client-only":"16s5h","./components/combobox/combobox.js":false,"./components/dialog/dialog.js":"jERgf","./components/disclosure/disclosure.js":false,"./components/focus-trap/focus-trap.js":false,"./components/listbox/listbox.js":false,"./components/menu/menu.js":false,"./components/popover/popover.js":false,"./components/radio-group/radio-group.js":false,"./components/switch/switch.js":false,"./components/tabs/tabs.js":false,"./components/transitions/transition.js":"03gOy","./components/portal/portal.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"16s5h":[function(require,module,exports) {

},{}],"jERgf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>_t);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _matchJs = require("../../utils/match.js");
var _renderJs = require("../../utils/render.js");
var _useSyncRefsJs = require("../../hooks/use-sync-refs.js");
var _keyboardJs = require("../keyboard.js");
var _bugsJs = require("../../utils/bugs.js");
var _useIdJs = require("../../hooks/use-id.js");
var _focusTrapJs = require("../../components/focus-trap/focus-trap.js");
var _portalJs = require("../../components/portal/portal.js");
var _portalForceRootJs = require("../../internal/portal-force-root.js");
var _descriptionJs = require("../description/description.js");
var _openClosedJs = require("../../internal/open-closed.js");
var _useServerHandoffCompleteJs = require("../../hooks/use-server-handoff-complete.js");
var _stackContextJs = require("../../internal/stack-context.js");
var _useOutsideClickJs = require("../../hooks/use-outside-click.js");
var _useOwnerJs = require("../../hooks/use-owner.js");
var _useEventListenerJs = require("../../hooks/use-event-listener.js");
var _useEventJs = require("../../hooks/use-event.js");
var _useDocumentOverflowJs = require("../../hooks/document-overflow/use-document-overflow.js");
var _useInertJs = require("../../hooks/use-inert.js");
var _useRootContainersJs = require("../../hooks/use-root-containers.js");
var _e = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))(_e || {}), Ie = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))(Ie || {});
let Me = {
    [0] (t, e) {
        return t.titleId === e.id ? t : {
            ...t,
            titleId: e.id
        };
    }
}, I = (0, _react.createContext)(null);
I.displayName = "DialogContext";
function b(t) {
    let e = (0, _react.useContext)(I);
    if (e === null) {
        let o = new Error(`<${t} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, b), o;
    }
    return e;
}
function we(t, e, o = ()=>[
        document.body
    ]) {
    (0, _useDocumentOverflowJs.useDocumentOverflowLockedEffect)(t, e, (i)=>{
        var n;
        return {
            containers: [
                ...(n = i.containers) != null ? n : [],
                o
            ]
        };
    });
}
function Be(t, e) {
    return (0, _matchJs.match)(e.type, Me, t, e);
}
let He = "div", Ge = (0, _renderJs.Features).RenderStrategy | (0, _renderJs.Features).Static;
function Ne(t, e) {
    var X;
    let o = (0, _useIdJs.useId)(), { id: i = `headlessui-dialog-${o}`, open: n, onClose: l, initialFocus: s, __demoMode: g = !1, ...T } = t, [m, h] = (0, _react.useState)(0), a = (0, _openClosedJs.useOpenClosed)();
    n === void 0 && a !== null && (n = (a & (0, _openClosedJs.State).Open) === (0, _openClosedJs.State).Open);
    let D = (0, _react.useRef)(null), Q = (0, _useSyncRefsJs.useSyncRefs)(D, e), f = (0, _useOwnerJs.useOwnerDocument)(D), N = t.hasOwnProperty("open") || a !== null, U = t.hasOwnProperty("onClose");
    if (!N && !U) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!N) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!U) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof n != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);
    if (typeof l != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);
    let p = n ? 0 : 1, [S, Z] = (0, _react.useReducer)(Be, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, _react.createRef)()
    }), P = (0, _useEventJs.useEvent)(()=>l(!1)), W = (0, _useEventJs.useEvent)((r)=>Z({
            type: 0,
            id: r
        })), L = (0, _useServerHandoffCompleteJs.useServerHandoffComplete)() ? g ? !1 : p === 0 : !1, F = m > 1, Y = (0, _react.useContext)(I) !== null, [ee, te] = (0, _portalJs.useNestedPortals)(), { resolveContainers: M, mainTreeNodeRef: k, MainTreeNode: oe } = (0, _useRootContainersJs.useRootContainers)({
        portals: ee,
        defaultContainers: [
            (X = S.panelRef.current) != null ? X : D.current
        ]
    }), re = F ? "parent" : "leaf", $ = a !== null ? (a & (0, _openClosedJs.State).Closing) === (0, _openClosedJs.State).Closing : !1, ne = (()=>Y || $ ? !1 : L)(), le = (0, _react.useCallback)(()=>{
        var r, c;
        return (c = Array.from((r = f == null ? void 0 : f.querySelectorAll("body > *")) != null ? r : []).find((d)=>d.id === "headlessui-portal-root" ? !1 : d.contains(k.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        k
    ]);
    (0, _useInertJs.useInert)(le, ne);
    let ae = (()=>F ? !0 : L)(), ie = (0, _react.useCallback)(()=>{
        var r, c;
        return (c = Array.from((r = f == null ? void 0 : f.querySelectorAll("[data-headlessui-portal]")) != null ? r : []).find((d)=>d.contains(k.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        k
    ]);
    (0, _useInertJs.useInert)(ie, ae);
    let se = (()=>!(!L || F))();
    (0, _useOutsideClickJs.useOutsideClick)(M, P, se);
    let pe = (()=>!(F || p !== 0))();
    (0, _useEventListenerJs.useEventListener)(f == null ? void 0 : f.defaultView, "keydown", (r)=>{
        pe && (r.defaultPrevented || r.key === (0, _keyboardJs.Keys).Escape && (r.preventDefault(), r.stopPropagation(), P()));
    });
    let de = (()=>!($ || p !== 0 || Y))();
    we(f, de, M), (0, _react.useEffect)(()=>{
        if (p !== 0 || !D.current) return;
        let r = new ResizeObserver((c)=>{
            for (let d of c){
                let x = d.target.getBoundingClientRect();
                x.x === 0 && x.y === 0 && x.width === 0 && x.height === 0 && P();
            }
        });
        return r.observe(D.current), ()=>r.disconnect();
    }, [
        p,
        D,
        P
    ]);
    let [ue, fe] = (0, _descriptionJs.useDescriptions)(), ge = (0, _react.useMemo)(()=>[
            {
                dialogState: p,
                close: P,
                setTitleId: W
            },
            S
        ], [
        p,
        S,
        P,
        W
    ]), J = (0, _react.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), Te = {
        ref: Q,
        id: i,
        role: "dialog",
        "aria-modal": p === 0 ? !0 : void 0,
        "aria-labelledby": S.titleId,
        "aria-describedby": ue
    };
    return (0, _reactDefault.default).createElement((0, _stackContextJs.StackProvider), {
        type: "Dialog",
        enabled: p === 0,
        element: D,
        onUpdate: (0, _useEventJs.useEvent)((r, c)=>{
            c === "Dialog" && (0, _matchJs.match)(r, {
                [(0, _stackContextJs.StackMessage).Add]: ()=>h((d)=>d + 1),
                [(0, _stackContextJs.StackMessage).Remove]: ()=>h((d)=>d - 1)
            });
        })
    }, (0, _reactDefault.default).createElement((0, _portalForceRootJs.ForcePortalRoot), {
        force: !0
    }, (0, _reactDefault.default).createElement((0, _portalJs.Portal), null, (0, _reactDefault.default).createElement(I.Provider, {
        value: ge
    }, (0, _reactDefault.default).createElement((0, _portalJs.Portal).Group, {
        target: D
    }, (0, _reactDefault.default).createElement((0, _portalForceRootJs.ForcePortalRoot), {
        force: !1
    }, (0, _reactDefault.default).createElement(fe, {
        slot: J,
        name: "Dialog.Description"
    }, (0, _reactDefault.default).createElement((0, _focusTrapJs.FocusTrap), {
        initialFocus: s,
        containers: M,
        features: L ? (0, _matchJs.match)(re, {
            parent: (0, _focusTrapJs.FocusTrap).features.RestoreFocus,
            leaf: (0, _focusTrapJs.FocusTrap).features.All & ~(0, _focusTrapJs.FocusTrap).features.FocusLock
        }) : (0, _focusTrapJs.FocusTrap).features.None
    }, (0, _reactDefault.default).createElement(te, null, (0, _renderJs.render)({
        ourProps: Te,
        theirProps: T,
        slot: J,
        defaultTag: He,
        features: Ge,
        visible: p === 0,
        name: "Dialog"
    }))))))))), (0, _reactDefault.default).createElement(oe, null));
}
let Ue = "div";
function We(t, e) {
    let o = (0, _useIdJs.useId)(), { id: i = `headlessui-dialog-overlay-${o}`, ...n } = t, [{ dialogState: l, close: s }] = b("Dialog.Overlay"), g = (0, _useSyncRefsJs.useSyncRefs)(e), T = (0, _useEventJs.useEvent)((a)=>{
        if (a.target === a.currentTarget) {
            if ((0, _bugsJs.isDisabledReactIssue7711)(a.currentTarget)) return a.preventDefault();
            a.preventDefault(), a.stopPropagation(), s();
        }
    }), m = (0, _react.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, _renderJs.render)({
        ourProps: {
            ref: g,
            id: i,
            "aria-hidden": !0,
            onClick: T
        },
        theirProps: n,
        slot: m,
        defaultTag: Ue,
        name: "Dialog.Overlay"
    });
}
let Ye = "div";
function $e(t, e) {
    let o = (0, _useIdJs.useId)(), { id: i = `headlessui-dialog-backdrop-${o}`, ...n } = t, [{ dialogState: l }, s] = b("Dialog.Backdrop"), g = (0, _useSyncRefsJs.useSyncRefs)(e);
    (0, _react.useEffect)(()=>{
        if (s.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        s.panelRef
    ]);
    let T = (0, _react.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, _reactDefault.default).createElement((0, _portalForceRootJs.ForcePortalRoot), {
        force: !0
    }, (0, _reactDefault.default).createElement((0, _portalJs.Portal), null, (0, _renderJs.render)({
        ourProps: {
            ref: g,
            id: i,
            "aria-hidden": !0
        },
        theirProps: n,
        slot: T,
        defaultTag: Ye,
        name: "Dialog.Backdrop"
    })));
}
let Je = "div";
function Xe(t, e) {
    let o = (0, _useIdJs.useId)(), { id: i = `headlessui-dialog-panel-${o}`, ...n } = t, [{ dialogState: l }, s] = b("Dialog.Panel"), g = (0, _useSyncRefsJs.useSyncRefs)(e, s.panelRef), T = (0, _react.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), m = (0, _useEventJs.useEvent)((a)=>{
        a.stopPropagation();
    });
    return (0, _renderJs.render)({
        ourProps: {
            ref: g,
            id: i,
            onClick: m
        },
        theirProps: n,
        slot: T,
        defaultTag: Je,
        name: "Dialog.Panel"
    });
}
let je = "h2";
function Ke(t, e) {
    let o = (0, _useIdJs.useId)(), { id: i = `headlessui-dialog-title-${o}`, ...n } = t, [{ dialogState: l, setTitleId: s }] = b("Dialog.Title"), g = (0, _useSyncRefsJs.useSyncRefs)(e);
    (0, _react.useEffect)(()=>(s(i), ()=>s(null)), [
        i,
        s
    ]);
    let T = (0, _react.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, _renderJs.render)({
        ourProps: {
            ref: g,
            id: i
        },
        theirProps: n,
        slot: T,
        defaultTag: je,
        name: "Dialog.Title"
    });
}
let Ve = (0, _renderJs.forwardRefWithAs)(Ne), qe = (0, _renderJs.forwardRefWithAs)($e), ze = (0, _renderJs.forwardRefWithAs)(Xe), Qe = (0, _renderJs.forwardRefWithAs)(We), Ze = (0, _renderJs.forwardRefWithAs)(Ke), _t = Object.assign(Ve, {
    Backdrop: qe,
    Panel: ze,
    Overlay: Qe,
    Title: Ze,
    Description: (0, _descriptionJs.Description)
});

},{"react":"6uln9","../../utils/match.js":"AWHzT","../../utils/render.js":"hFxMl","../../hooks/use-sync-refs.js":"61fW1","../keyboard.js":"iVXBL","../../utils/bugs.js":"8l3GP","../../hooks/use-id.js":"ewTbn","../../components/focus-trap/focus-trap.js":"3n335","../../components/portal/portal.js":"52QbR","../../internal/portal-force-root.js":"cei7w","../description/description.js":"hQSyF","../../internal/open-closed.js":"UnZmT","../../hooks/use-server-handoff-complete.js":"bJA23","../../internal/stack-context.js":"7AirO","../../hooks/use-outside-click.js":"7Xjo6","../../hooks/use-owner.js":"6wF89","../../hooks/use-event-listener.js":"jWOo6","../../hooks/use-event.js":"6LkpW","../../hooks/document-overflow/use-document-overflow.js":"9fKsd","../../hooks/use-inert.js":"kSJbu","../../hooks/use-root-containers.js":"6fnym","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"AWHzT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "match", ()=>u);
function u(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, u), t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hFxMl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Features", ()=>S);
parcelHelpers.export(exports, "RenderStrategy", ()=>j);
parcelHelpers.export(exports, "compact", ()=>R);
parcelHelpers.export(exports, "forwardRefWithAs", ()=>D);
parcelHelpers.export(exports, "render", ()=>X);
var _react = require("react");
var _classNamesJs = require("./class-names.js");
var _matchJs = require("./match.js");
var S = ((a)=>(a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))(S || {}), j = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(j || {});
function X({ ourProps: r, theirProps: t, slot: e, defaultTag: a, features: s, visible: n = !0, name: f }) {
    let o = N(t, r);
    if (n) return c(o, e, a, f);
    let u = s != null ? s : 0;
    if (u & 2) {
        let { static: l = !1, ...p } = o;
        if (l) return c(p, e, a, f);
    }
    if (u & 1) {
        let { unmount: l = !0, ...p } = o;
        return (0, _matchJs.match)(l ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return c({
                    ...p,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, a, f);
            }
        });
    }
    return c(o, e, a, f);
}
function c(r, t = {}, e, a) {
    let { as: s = e, children: n, refName: f = "ref", ...o } = g(r, [
        "unmount",
        "static"
    ]), u = r.ref !== void 0 ? {
        [f]: r.ref
    } : {}, l = typeof n == "function" ? n(t) : n;
    "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(t));
    let p = {};
    if (t) {
        let i = !1, m = [];
        for (let [y, d] of Object.entries(t))typeof d == "boolean" && (i = !0), d === !0 && m.push(y);
        i && (p["data-headlessui-state"] = m.join(" "));
    }
    if (s === (0, _react.Fragment) && Object.keys(R(o)).length > 0) {
        if (!(0, _react.isValidElement)(l) || Array.isArray(l) && l.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${a} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(o).map((d)=>`  - ${d}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((d)=>`  - ${d}`).join(`
`)
        ].join(`
`));
        let i = l.props, m = typeof (i == null ? void 0 : i.className) == "function" ? (...d)=>(0, _classNamesJs.classNames)(i == null ? void 0 : i.className(...d), o.className) : (0, _classNamesJs.classNames)(i == null ? void 0 : i.className, o.className), y = m ? {
            className: m
        } : {};
        return (0, _react.cloneElement)(l, Object.assign({}, N(l.props, R(g(o, [
            "ref"
        ]))), p, u, w(l.ref, u.ref), y));
    }
    return (0, _react.createElement)(s, Object.assign({}, g(o, [
        "ref"
    ]), s !== (0, _react.Fragment) && u, s !== (0, _react.Fragment) && p), l);
}
function w(...r) {
    return {
        ref: r.every((t)=>t == null) ? void 0 : (t)=>{
            for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
        }
    };
}
function N(...r) {
    var a;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let s of r)for(let n in s)n.startsWith("on") && typeof s[n] == "function" ? ((a = e[n]) != null || (e[n] = []), e[n].push(s[n])) : t[n] = s[n];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((s)=>[
            s,
            void 0
        ])));
    for(let s in e)Object.assign(t, {
        [s] (n, ...f) {
            let o = e[s];
            for (let u of o){
                if ((n instanceof Event || (n == null ? void 0 : n.nativeEvent) instanceof Event) && n.defaultPrevented) return;
                u(n, ...f);
            }
        }
    });
    return t;
}
function D(r) {
    var t;
    return Object.assign((0, _react.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function R(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function g(r, t = []) {
    let e = Object.assign({}, r);
    for (let a of t)a in e && delete e[a];
    return e;
}

},{"react":"6uln9","./class-names.js":"9OIM4","./match.js":"AWHzT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9OIM4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "classNames", ()=>e);
function e(...n) {
    return n.filter(Boolean).join(" ");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"61fW1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optionalRef", ()=>T);
parcelHelpers.export(exports, "useSyncRefs", ()=>y);
var _react = require("react");
var _useEventJs = require("./use-event.js");
let u = Symbol();
function T(t, n = !0) {
    return Object.assign(t, {
        [u]: n
    });
}
function y(...t) {
    let n = (0, _react.useRef)(t);
    (0, _react.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, _useEventJs.useEvent)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[u])) ? void 0 : c;
}

},{"react":"6uln9","./use-event.js":"6LkpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6LkpW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEvent", ()=>o);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useLatestValueJs = require("./use-latest-value.js");
let o = function(t) {
    let e = (0, _useLatestValueJs.useLatestValue)(t);
    return (0, _reactDefault.default).useCallback((...r)=>e.current(...r), [
        e
    ]);
};

},{"react":"6uln9","./use-latest-value.js":"f2MN3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2MN3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLatestValue", ()=>s);
var _react = require("react");
var _useIsoMorphicEffectJs = require("./use-iso-morphic-effect.js");
function s(e) {
    let r = (0, _react.useRef)(e);
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}

},{"react":"6uln9","./use-iso-morphic-effect.js":"1Aklk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Aklk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsoMorphicEffect", ()=>l);
var _react = require("react");
var _envJs = require("../utils/env.js");
let l = (e, f)=>{
    (0, _envJs.env).isServer ? (0, _react.useEffect)(e, f) : (0, _react.useLayoutEffect)(e, f);
};

},{"react":"6uln9","../utils/env.js":"7VTsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VTsa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "env", ()=>s);
var i = Object.defineProperty;
var d = (t, e, n)=>e in t ? i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var r = (t, e, n)=>(d(t, typeof e != "symbol" ? e + "" : e, n), n);
class o {
    constructor(){
        r(this, "current", this.detect());
        r(this, "handoffState", "pending");
        r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let s = new o;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iVXBL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Keys", ()=>o);
var o = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))(o || {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8l3GP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDisabledReactIssue7711", ()=>r);
function r(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && i(l) ? !1 : t;
}
function i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ewTbn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", ()=>I);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsoMorphicEffectJs = require("./use-iso-morphic-effect.js");
var _useServerHandoffCompleteJs = require("./use-server-handoff-complete.js");
var _envJs = require("../utils/env.js");
var o;
let I = (o = (0, _reactDefault.default).useId) != null ? o : function() {
    let n = (0, _useServerHandoffCompleteJs.useServerHandoffComplete)(), [e, u] = (0, _reactDefault.default).useState(n ? ()=>(0, _envJs.env).nextId() : null);
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        e === null && u((0, _envJs.env).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};

},{"react":"6uln9","./use-iso-morphic-effect.js":"1Aklk","./use-server-handoff-complete.js":"bJA23","../utils/env.js":"7VTsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bJA23":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useServerHandoffComplete", ()=>l);
var _react = require("react");
var _envJs = require("../utils/env.js");
function l() {
    let [e, f] = (0, _react.useState)((0, _envJs.env).isHandoffComplete);
    return e && (0, _envJs.env).isHandoffComplete === !1 && f(!1), (0, _react.useEffect)(()=>{
        e !== !0 && f(!0);
    }, [
        e
    ]), (0, _react.useEffect)(()=>(0, _envJs.env).handoff(), []), e;
}

},{"react":"6uln9","../utils/env.js":"7VTsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3n335":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusTrap", ()=>ge);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderJs = require("../../utils/render.js");
var _useServerHandoffCompleteJs = require("../../hooks/use-server-handoff-complete.js");
var _useSyncRefsJs = require("../../hooks/use-sync-refs.js");
var _hiddenJs = require("../../internal/hidden.js");
var _focusManagementJs = require("../../utils/focus-management.js");
var _matchJs = require("../../utils/match.js");
var _useEventJs = require("../../hooks/use-event.js");
var _useTabDirectionJs = require("../../hooks/use-tab-direction.js");
var _useIsMountedJs = require("../../hooks/use-is-mounted.js");
var _useOwnerJs = require("../../hooks/use-owner.js");
var _useEventListenerJs = require("../../hooks/use-event-listener.js");
var _microTaskJs = require("../../utils/micro-task.js");
var _useWatchJs = require("../../hooks/use-watch.js");
var _useDisposablesJs = require("../../hooks/use-disposables.js");
var _documentReadyJs = require("../../utils/document-ready.js");
var _useOnUnmountJs = require("../../hooks/use-on-unmount.js");
function P(t) {
    if (!t) return new Set;
    if (typeof t == "function") return new Set(t());
    let r = new Set;
    for (let e of t.current)e.current instanceof HTMLElement && r.add(e.current);
    return r;
}
let J = "div";
var h = ((n)=>(n[n.None = 1] = "None", n[n.InitialFocus = 2] = "InitialFocus", n[n.TabLock = 4] = "TabLock", n[n.FocusLock = 8] = "FocusLock", n[n.RestoreFocus = 16] = "RestoreFocus", n[n.All = 30] = "All", n))(h || {});
function X(t, r) {
    let e = (0, _react.useRef)(null), o = (0, _useSyncRefsJs.useSyncRefs)(e, r), { initialFocus: u, containers: i, features: n = 30, ...l } = t;
    (0, _useServerHandoffCompleteJs.useServerHandoffComplete)() || (n = 1);
    let m = (0, _useOwnerJs.useOwnerDocument)(e);
    Y({
        ownerDocument: m
    }, Boolean(n & 16));
    let c = Z({
        ownerDocument: m,
        container: e,
        initialFocus: u
    }, Boolean(n & 2));
    $({
        ownerDocument: m,
        container: e,
        containers: i,
        previousActiveElement: c
    }, Boolean(n & 8));
    let v = (0, _useTabDirectionJs.useTabDirection)(), y = (0, _useEventJs.useEvent)((s)=>{
        let T = e.current;
        if (!T) return;
        ((B)=>B())(()=>{
            (0, _matchJs.match)(v.current, {
                [(0, _useTabDirectionJs.Direction).Forwards]: ()=>{
                    (0, _focusManagementJs.focusIn)(T, (0, _focusManagementJs.Focus).First, {
                        skipElements: [
                            s.relatedTarget
                        ]
                    });
                },
                [(0, _useTabDirectionJs.Direction).Backwards]: ()=>{
                    (0, _focusManagementJs.focusIn)(T, (0, _focusManagementJs.Focus).Last, {
                        skipElements: [
                            s.relatedTarget
                        ]
                    });
                }
            });
        });
    }), _ = (0, _useDisposablesJs.useDisposables)(), b = (0, _react.useRef)(!1), j = {
        ref: o,
        onKeyDown (s) {
            s.key == "Tab" && (b.current = !0, _.requestAnimationFrame(()=>{
                b.current = !1;
            }));
        },
        onBlur (s) {
            let T = P(i);
            e.current instanceof HTMLElement && T.add(e.current);
            let d = s.relatedTarget;
            d instanceof HTMLElement && d.dataset.headlessuiFocusGuard !== "true" && (S(T, d) || (b.current ? (0, _focusManagementJs.focusIn)(e.current, (0, _matchJs.match)(v.current, {
                [(0, _useTabDirectionJs.Direction).Forwards]: ()=>(0, _focusManagementJs.Focus).Next,
                [(0, _useTabDirectionJs.Direction).Backwards]: ()=>(0, _focusManagementJs.Focus).Previous
            }) | (0, _focusManagementJs.Focus).WrapAround, {
                relativeTo: s.target
            }) : s.target instanceof HTMLElement && (0, _focusManagementJs.focusElement)(s.target)));
        }
    };
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, Boolean(n & 4) && (0, _reactDefault.default).createElement((0, _hiddenJs.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: y,
        features: (0, _hiddenJs.Features).Focusable
    }), (0, _renderJs.render)({
        ourProps: j,
        theirProps: l,
        defaultTag: J,
        name: "FocusTrap"
    }), Boolean(n & 4) && (0, _reactDefault.default).createElement((0, _hiddenJs.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: y,
        features: (0, _hiddenJs.Features).Focusable
    }));
}
let z = (0, _renderJs.forwardRefWithAs)(X), ge = Object.assign(z, {
    features: h
}), a = [];
(0, _documentReadyJs.onDocumentReady)(()=>{
    function t(r) {
        r.target instanceof HTMLElement && r.target !== document.body && a[0] !== r.target && (a.unshift(r.target), a = a.filter((e)=>e != null && e.isConnected), a.splice(10));
    }
    window.addEventListener("click", t, {
        capture: !0
    }), window.addEventListener("mousedown", t, {
        capture: !0
    }), window.addEventListener("focus", t, {
        capture: !0
    }), document.body.addEventListener("click", t, {
        capture: !0
    }), document.body.addEventListener("mousedown", t, {
        capture: !0
    }), document.body.addEventListener("focus", t, {
        capture: !0
    });
});
function Q(t = !0) {
    let r = (0, _react.useRef)(a.slice());
    return (0, _useWatchJs.useWatch)(([e], [o])=>{
        o === !0 && e === !1 && (0, _microTaskJs.microTask)(()=>{
            r.current.splice(0);
        }), o === !1 && e === !0 && (r.current = a.slice());
    }, [
        t,
        a,
        r
    ]), (0, _useEventJs.useEvent)(()=>{
        var e;
        return (e = r.current.find((o)=>o != null && o.isConnected)) != null ? e : null;
    });
}
function Y({ ownerDocument: t }, r) {
    let e = Q(r);
    (0, _useWatchJs.useWatch)(()=>{
        r || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && (0, _focusManagementJs.focusElement)(e());
    }, [
        r
    ]), (0, _useOnUnmountJs.useOnUnmount)(()=>{
        r && (0, _focusManagementJs.focusElement)(e());
    });
}
function Z({ ownerDocument: t, container: r, initialFocus: e }, o) {
    let u = (0, _react.useRef)(null), i = (0, _useIsMountedJs.useIsMounted)();
    return (0, _useWatchJs.useWatch)(()=>{
        if (!o) return;
        let n = r.current;
        n && (0, _microTaskJs.microTask)(()=>{
            if (!i.current) return;
            let l = t == null ? void 0 : t.activeElement;
            if (e != null && e.current) {
                if ((e == null ? void 0 : e.current) === l) {
                    u.current = l;
                    return;
                }
            } else if (n.contains(l)) {
                u.current = l;
                return;
            }
            e != null && e.current ? (0, _focusManagementJs.focusElement)(e.current) : (0, _focusManagementJs.focusIn)(n, (0, _focusManagementJs.Focus).First) === (0, _focusManagementJs.FocusResult).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), u.current = t == null ? void 0 : t.activeElement;
        });
    }, [
        o
    ]), u;
}
function $({ ownerDocument: t, container: r, containers: e, previousActiveElement: o }, u) {
    let i = (0, _useIsMountedJs.useIsMounted)();
    (0, _useEventListenerJs.useEventListener)(t == null ? void 0 : t.defaultView, "focus", (n)=>{
        if (!u || !i.current) return;
        let l = P(e);
        r.current instanceof HTMLElement && l.add(r.current);
        let m = o.current;
        if (!m) return;
        let c = n.target;
        c && c instanceof HTMLElement ? S(l, c) ? (o.current = c, (0, _focusManagementJs.focusElement)(c)) : (n.preventDefault(), n.stopPropagation(), (0, _focusManagementJs.focusElement)(m)) : (0, _focusManagementJs.focusElement)(o.current);
    }, !0);
}
function S(t, r) {
    for (let e of t)if (e.contains(r)) return !0;
    return !1;
}

},{"react":"6uln9","../../utils/render.js":"hFxMl","../../hooks/use-server-handoff-complete.js":"bJA23","../../hooks/use-sync-refs.js":"61fW1","../../internal/hidden.js":"kQcB8","../../utils/focus-management.js":"f9ZB3","../../utils/match.js":"AWHzT","../../hooks/use-event.js":"6LkpW","../../hooks/use-tab-direction.js":"gWy9z","../../hooks/use-is-mounted.js":"4Sa1d","../../hooks/use-owner.js":"6wF89","../../hooks/use-event-listener.js":"jWOo6","../../utils/micro-task.js":"73O4s","../../hooks/use-watch.js":"4yAr0","../../hooks/use-disposables.js":"kS4kq","../../utils/document-ready.js":"f2EEi","../../hooks/use-on-unmount.js":"edKMj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQcB8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Features", ()=>p);
parcelHelpers.export(exports, "Hidden", ()=>c);
var _renderJs = require("../utils/render.js");
let a = "div";
var p = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(p || {});
function s(t, o) {
    let { features: n = 1, ...e } = t, d = {
        ref: o,
        "aria-hidden": (n & 2) === 2 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(n & 4) === 4 && (n & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, _renderJs.render)({
        ourProps: d,
        theirProps: e,
        slot: {},
        defaultTag: a,
        name: "Hidden"
    });
}
let c = (0, _renderJs.forwardRefWithAs)(s);

},{"../utils/render.js":"hFxMl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f9ZB3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Focus", ()=>M);
parcelHelpers.export(exports, "FocusResult", ()=>N);
parcelHelpers.export(exports, "FocusableMode", ()=>T);
parcelHelpers.export(exports, "focusElement", ()=>y);
parcelHelpers.export(exports, "focusFrom", ()=>_);
parcelHelpers.export(exports, "focusIn", ()=>O);
parcelHelpers.export(exports, "getFocusableElements", ()=>f);
parcelHelpers.export(exports, "isFocusableElement", ()=>h);
parcelHelpers.export(exports, "restoreFocusIfNecessary", ()=>D);
parcelHelpers.export(exports, "sortByDomNode", ()=>I);
var _disposablesJs = require("./disposables.js");
var _matchJs = require("./match.js");
var _ownerJs = require("./owner.js");
let c = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var M = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))(M || {}), N = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))(N || {}), F = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))(F || {});
function f(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll(c)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var T = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(T || {});
function h(e, r = 0) {
    var t;
    return e === ((t = (0, _ownerJs.getOwnerDocument)(e)) == null ? void 0 : t.body) ? !1 : (0, _matchJs.match)(r, {
        [0] () {
            return e.matches(c);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches(c)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function D(e) {
    let r = (0, _ownerJs.getOwnerDocument)(e);
    (0, _disposablesJs.disposables)().nextFrame(()=>{
        r && !h(r.activeElement, 0) && y(e);
    });
}
var w = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))(w || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function y(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let S = [
    "textarea",
    "input"
].join(",");
function H(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, S)) != null ? t : !1;
}
function I(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let o = r(t), i = r(l);
        if (o === null || i === null) return 0;
        let n = o.compareDocumentPosition(i);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function _(e, r) {
    return O(f(), r, {
        relativeTo: e
    });
}
function O(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, n = Array.isArray(e) ? t ? I(e) : e : f(e);
    o.length > 0 && n.length > 1 && (n = n.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let E = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
        if (r & 8) return n.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = r & 32 ? {
        preventScroll: !0
    } : {}, d = 0, a = n.length, u;
    do {
        if (d >= a || d + a <= 0) return 0;
        let s = x + d;
        if (r & 16) s = (s + a) % a;
        else {
            if (s < 0) return 3;
            if (s >= a) return 1;
        }
        u = n[s], u == null || u.focus(p), d += E;
    }while (u !== i.activeElement);
    return r & 6 && H(u) && u.select(), 2;
}

},{"./disposables.js":"6bVHS","./match.js":"AWHzT","./owner.js":"c71bk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6bVHS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disposables", ()=>o);
var _microTaskJs = require("./micro-task.js");
function o() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, _microTaskJs.microTask)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = o();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}

},{"./micro-task.js":"73O4s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73O4s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "microTask", ()=>t);
function t(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c71bk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOwnerDocument", ()=>e);
var _envJs = require("./env.js");
function e(r) {
    return (0, _envJs.env).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}

},{"./env.js":"7VTsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gWy9z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Direction", ()=>s);
parcelHelpers.export(exports, "useTabDirection", ()=>n);
var _react = require("react");
var _useWindowEventJs = require("./use-window-event.js");
var s = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))(s || {});
function n() {
    let e = (0, _react.useRef)(0);
    return (0, _useWindowEventJs.useWindowEvent)("keydown", (o)=>{
        o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
    }, !0), e;
}

},{"react":"6uln9","./use-window-event.js":"kI16d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kI16d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWindowEvent", ()=>s);
var _react = require("react");
var _useLatestValueJs = require("./use-latest-value.js");
function s(e, r, n) {
    let o = (0, _useLatestValueJs.useLatestValue)(r);
    (0, _react.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}

},{"react":"6uln9","./use-latest-value.js":"f2MN3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Sa1d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMounted", ()=>f);
var _react = require("react");
var _useIsoMorphicEffectJs = require("./use-iso-morphic-effect.js");
function f() {
    let e = (0, _react.useRef)(!1);
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}

},{"react":"6uln9","./use-iso-morphic-effect.js":"1Aklk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wF89":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOwnerDocument", ()=>n);
var _react = require("react");
var _ownerJs = require("../utils/owner.js");
function n(...e) {
    return (0, _react.useMemo)(()=>(0, _ownerJs.getOwnerDocument)(...e), [
        ...e
    ]);
}

},{"react":"6uln9","../utils/owner.js":"c71bk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jWOo6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEventListener", ()=>E);
var _react = require("react");
var _useLatestValueJs = require("./use-latest-value.js");
function E(n, e, a, t) {
    let i = (0, _useLatestValueJs.useLatestValue)(a);
    (0, _react.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}

},{"react":"6uln9","./use-latest-value.js":"f2MN3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4yAr0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWatch", ()=>m);
var _react = require("react");
var _useEventJs = require("./use-event.js");
function m(u, t) {
    let e = (0, _react.useRef)([]), r = (0, _useEventJs.useEvent)(u);
    (0, _react.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [n, a] of t.entries())if (e.current[n] !== a) {
            let l = r(t, o);
            return e.current = t, l;
        }
    }, [
        r,
        ...t
    ]);
}

},{"react":"6uln9","./use-event.js":"6LkpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kS4kq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDisposables", ()=>p);
var _react = require("react");
var _disposablesJs = require("../utils/disposables.js");
function p() {
    let [e] = (0, _react.useState)((0, _disposablesJs.disposables));
    return (0, _react.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}

},{"react":"6uln9","../utils/disposables.js":"6bVHS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2EEi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onDocumentReady", ()=>t);
function t(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"edKMj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOnUnmount", ()=>c);
var _react = require("react");
var _microTaskJs = require("../utils/micro-task.js");
var _useEventJs = require("./use-event.js");
function c(t) {
    let r = (0, _useEventJs.useEvent)(t), e = (0, _react.useRef)(!1);
    (0, _react.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, _microTaskJs.microTask)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}

},{"react":"6uln9","../utils/micro-task.js":"73O4s","./use-event.js":"6LkpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"52QbR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>pe);
parcelHelpers.export(exports, "useNestedPortals", ()=>ae);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _renderJs = require("../../utils/render.js");
var _useIsoMorphicEffectJs = require("../../hooks/use-iso-morphic-effect.js");
var _portalForceRootJs = require("../../internal/portal-force-root.js");
var _useServerHandoffCompleteJs = require("../../hooks/use-server-handoff-complete.js");
var _useSyncRefsJs = require("../../hooks/use-sync-refs.js");
var _useOnUnmountJs = require("../../hooks/use-on-unmount.js");
var _useOwnerJs = require("../../hooks/use-owner.js");
var _envJs = require("../../utils/env.js");
var _useEventJs = require("../../hooks/use-event.js");
function F(p) {
    let l = (0, _portalForceRootJs.usePortalRoot)(), n = (0, _react.useContext)(v), e = (0, _useOwnerJs.useOwnerDocument)(p), [a, o] = (0, _react.useState)(()=>{
        if (!l && n !== null || (0, _envJs.env).isServer) return null;
        let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (t) return t;
        if (e === null) return null;
        let r = e.createElement("div");
        return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
    });
    return (0, _react.useEffect)(()=>{
        a !== null && (e != null && e.body.contains(a) || e == null || e.body.appendChild(a));
    }, [
        a,
        e
    ]), (0, _react.useEffect)(()=>{
        l || n !== null && o(n.current);
    }, [
        n,
        o,
        l
    ]), a;
}
let U = (0, _react.Fragment);
function N(p, l) {
    let n = p, e = (0, _react.useRef)(null), a = (0, _useSyncRefsJs.useSyncRefs)((0, _useSyncRefsJs.optionalRef)((u)=>{
        e.current = u;
    }), l), o = (0, _useOwnerJs.useOwnerDocument)(e), t = F(e), [r] = (0, _react.useState)(()=>{
        var u;
        return (0, _envJs.env).isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
    }), i = (0, _react.useContext)(f), C = (0, _useServerHandoffCompleteJs.useServerHandoffComplete)();
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        !t || !r || t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r));
    }, [
        t,
        r
    ]), (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        if (r && i) return i.register(r);
    }, [
        i,
        r
    ]), (0, _useOnUnmountJs.useOnUnmount)(()=>{
        var u;
        !t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((u = t.parentElement) == null || u.removeChild(t)));
    }), C ? !t || !r ? null : (0, _reactDom.createPortal)((0, _renderJs.render)({
        ourProps: {
            ref: a
        },
        theirProps: n,
        defaultTag: U,
        name: "Portal"
    }), r) : null;
}
let S = (0, _react.Fragment), v = (0, _react.createContext)(null);
function j(p, l) {
    let { target: n, ...e } = p, o = {
        ref: (0, _useSyncRefsJs.useSyncRefs)(l)
    };
    return (0, _reactDefault.default).createElement(v.Provider, {
        value: n
    }, (0, _renderJs.render)({
        ourProps: o,
        theirProps: e,
        defaultTag: S,
        name: "Popover.Group"
    }));
}
let f = (0, _react.createContext)(null);
function ae() {
    let p = (0, _react.useContext)(f), l = (0, _react.useRef)([]), n = (0, _useEventJs.useEvent)((o)=>(l.current.push(o), p && p.register(o), ()=>e(o))), e = (0, _useEventJs.useEvent)((o)=>{
        let t = l.current.indexOf(o);
        t !== -1 && l.current.splice(t, 1), p && p.unregister(o);
    }), a = (0, _react.useMemo)(()=>({
            register: n,
            unregister: e,
            portals: l
        }), [
        n,
        e,
        l
    ]);
    return [
        l,
        (0, _react.useMemo)(()=>function({ children: t }) {
                return (0, _reactDefault.default).createElement(f.Provider, {
                    value: a
                }, t);
            }, [
            a
        ])
    ];
}
let D = (0, _renderJs.forwardRefWithAs)(N), I = (0, _renderJs.forwardRefWithAs)(j), pe = Object.assign(D, {
    Group: I
});

},{"react":"6uln9","react-dom":"b8T3j","../../utils/render.js":"hFxMl","../../hooks/use-iso-morphic-effect.js":"1Aklk","../../internal/portal-force-root.js":"cei7w","../../hooks/use-server-handoff-complete.js":"bJA23","../../hooks/use-sync-refs.js":"61fW1","../../hooks/use-on-unmount.js":"edKMj","../../hooks/use-owner.js":"6wF89","../../utils/env.js":"7VTsa","../../hooks/use-event.js":"6LkpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cei7w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ForcePortalRoot", ()=>P);
parcelHelpers.export(exports, "usePortalRoot", ()=>l);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let e = (0, _react.createContext)(!1);
function l() {
    return (0, _react.useContext)(e);
}
function P(o) {
    return (0, _reactDefault.default).createElement(e.Provider, {
        value: o.force
    }, o.children);
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hQSyF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Description", ()=>b);
parcelHelpers.export(exports, "useDescriptions", ()=>M);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIdJs = require("../../hooks/use-id.js");
var _renderJs = require("../../utils/render.js");
var _useIsoMorphicEffectJs = require("../../hooks/use-iso-morphic-effect.js");
var _useSyncRefsJs = require("../../hooks/use-sync-refs.js");
var _useEventJs = require("../../hooks/use-event.js");
let d = (0, _react.createContext)(null);
function f() {
    let r = (0, _react.useContext)(d);
    if (r === null) {
        let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, f), t;
    }
    return r;
}
function M() {
    let [r, t] = (0, _react.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, _react.useMemo)(()=>function(e) {
                let i = (0, _useEventJs.useEvent)((s)=>(t((o)=>[
                            ...o,
                            s
                        ]), ()=>t((o)=>{
                            let p = o.slice(), c = p.indexOf(s);
                            return c !== -1 && p.splice(c, 1), p;
                        }))), n = (0, _react.useMemo)(()=>({
                        register: i,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    i,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, _reactDefault.default).createElement(d.Provider, {
                    value: n
                }, e.children);
            }, [
            t
        ])
    ];
}
let S = "p";
function h(r, t) {
    let a = (0, _useIdJs.useId)(), { id: e = `headlessui-description-${a}`, ...i } = r, n = f(), s = (0, _useSyncRefsJs.useSyncRefs)(t);
    (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>n.register(e), [
        e,
        n.register
    ]);
    let o = {
        ref: s,
        ...n.props,
        id: e
    };
    return (0, _renderJs.render)({
        ourProps: o,
        theirProps: i,
        slot: n.slot || {},
        defaultTag: S,
        name: n.name || "Description"
    });
}
let y = (0, _renderJs.forwardRefWithAs)(h), b = Object.assign(y, {});

},{"react":"6uln9","../../hooks/use-id.js":"ewTbn","../../utils/render.js":"hFxMl","../../hooks/use-iso-morphic-effect.js":"1Aklk","../../hooks/use-sync-refs.js":"61fW1","../../hooks/use-event.js":"6LkpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"UnZmT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenClosedProvider", ()=>c);
parcelHelpers.export(exports, "State", ()=>d);
parcelHelpers.export(exports, "useOpenClosed", ()=>C);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let n = (0, _react.createContext)(null);
n.displayName = "OpenClosedContext";
var d = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(d || {});
function C() {
    return (0, _react.useContext)(n);
}
function c({ value: o, children: r }) {
    return (0, _reactDefault.default).createElement(n.Provider, {
        value: o
    }, r);
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7AirO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StackMessage", ()=>s);
parcelHelpers.export(exports, "StackProvider", ()=>M);
parcelHelpers.export(exports, "useStackContext", ()=>x);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsoMorphicEffectJs = require("../hooks/use-iso-morphic-effect.js");
var _useEventJs = require("../hooks/use-event.js");
let a = (0, _react.createContext)(()=>{});
a.displayName = "StackContext";
var s = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(s || {});
function x() {
    return (0, _react.useContext)(a);
}
function M({ children: i, onUpdate: r, type: e, element: n, enabled: u }) {
    let l = x(), o = (0, _useEventJs.useEvent)((...t)=>{
        r == null || r(...t), l(...t);
    });
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        let t = u === void 0 || u === !0;
        return t && o(0, e, n), ()=>{
            t && o(1, e, n);
        };
    }, [
        o,
        e,
        n,
        u
    ]), (0, _reactDefault.default).createElement(a.Provider, {
        value: o
    }, i);
}

},{"react":"6uln9","../hooks/use-iso-morphic-effect.js":"1Aklk","../hooks/use-event.js":"6LkpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Xjo6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOutsideClick", ()=>h);
var _react = require("react");
var _focusManagementJs = require("../utils/focus-management.js");
var _useDocumentEventJs = require("./use-document-event.js");
var _useWindowEventJs = require("./use-window-event.js");
function h(s, m, a = !0) {
    let i = (0, _react.useRef)(!1);
    (0, _react.useEffect)(()=>{
        requestAnimationFrame(()=>{
            i.current = a;
        });
    }, [
        a
    ]);
    function c(e, r) {
        if (!i.current || e.defaultPrevented) return;
        let t = r(e);
        if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
        let E = function u(n) {
            return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(s);
        for (let u of E){
            if (u === null) continue;
            let n = u instanceof HTMLElement ? u : u.current;
            if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
        }
        return !(0, _focusManagementJs.isFocusableElement)(t, (0, _focusManagementJs.FocusableMode).Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
    }
    let o = (0, _react.useRef)(null);
    (0, _useDocumentEventJs.useDocumentEvent)("pointerdown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, _useDocumentEventJs.useDocumentEvent)("mousedown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, _useDocumentEventJs.useDocumentEvent)("click", (e)=>{
        o.current && (c(e, ()=>o.current), o.current = null);
    }, !0), (0, _useDocumentEventJs.useDocumentEvent)("touchend", (e)=>c(e, ()=>e.target instanceof HTMLElement ? e.target : null), !0), (0, _useWindowEventJs.useWindowEvent)("blur", (e)=>c(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}

},{"react":"6uln9","../utils/focus-management.js":"f9ZB3","./use-document-event.js":"g06Br","./use-window-event.js":"kI16d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g06Br":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDocumentEvent", ()=>d);
var _react = require("react");
var _useLatestValueJs = require("./use-latest-value.js");
function d(e, r, n) {
    let o = (0, _useLatestValueJs.useLatestValue)(r);
    (0, _react.useEffect)(()=>{
        function t(u) {
            o.current(u);
        }
        return document.addEventListener(e, t, n), ()=>document.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}

},{"react":"6uln9","./use-latest-value.js":"f2MN3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9fKsd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDocumentOverflowLockedEffect", ()=>p);
var _useIsoMorphicEffectJs = require("../use-iso-morphic-effect.js");
var _useStoreJs = require("../../hooks/use-store.js");
var _overflowStoreJs = require("./overflow-store.js");
function p(e, r, n) {
    let f = (0, _useStoreJs.useStore)((0, _overflowStoreJs.overflows)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        if (!(!e || !r)) return (0, _overflowStoreJs.overflows).dispatch("PUSH", e, n), ()=>(0, _overflowStoreJs.overflows).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}

},{"../use-iso-morphic-effect.js":"1Aklk","../../hooks/use-store.js":"8oKBf","./overflow-store.js":"f5diM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8oKBf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStore", ()=>S);
var _indexJs = require("../use-sync-external-store-shim/index.js");
function S(t) {
    return (0, _indexJs.useSyncExternalStore)(t.subscribe, t.getSnapshot, t.getSnapshot);
}

},{"../use-sync-external-store-shim/index.js":"2z1qc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2z1qc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>a);
var _react = require("react");
var _useSyncExternalStoreShimClientJs = require("./useSyncExternalStoreShimClient.js");
var _useSyncExternalStoreShimServerJs = require("./useSyncExternalStoreShimServer.js");
const r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", s = !r, c = s ? (0, _useSyncExternalStoreShimServerJs.useSyncExternalStore) : (0, _useSyncExternalStoreShimClientJs.useSyncExternalStore), a = "useSyncExternalStore" in _react ? ((n)=>n.useSyncExternalStore)(_react) : c;

},{"react":"6uln9","./useSyncExternalStoreShimClient.js":"hatp1","./useSyncExternalStoreShimServer.js":"7jkzX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hatp1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>y);
var _react = require("react");
function i(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const d = typeof Object.is == "function" ? Object.is : i, { useState: u, useEffect: h, useLayoutEffect: f, useDebugValue: p } = _react;
let S = !1, _ = !1;
function y(e, t, c) {
    const a = t(), [{ inst: n }, o] = u({
        inst: {
            value: a,
            getSnapshot: t
        }
    });
    return f(()=>{
        n.value = a, n.getSnapshot = t, r(n) && o({
            inst: n
        });
    }, [
        e,
        a,
        t
    ]), h(()=>(r(n) && o({
            inst: n
        }), e(()=>{
            r(n) && o({
                inst: n
            });
        })), [
        e
    ]), p(a), a;
}
function r(e) {
    const t = e.getSnapshot, c = e.value;
    try {
        const a = t();
        return !d(c, a);
    } catch  {
        return !0;
    }
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7jkzX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>t);
function t(r, e, n) {
    return e();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f5diM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overflows", ()=>a);
var _disposablesJs = require("../../utils/disposables.js");
var _storeJs = require("../../utils/store.js");
var _adjustScrollbarPaddingJs = require("./adjust-scrollbar-padding.js");
var _handleIosLockingJs = require("./handle-ios-locking.js");
var _preventScrollJs = require("./prevent-scroll.js");
function m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let a = (0, _storeJs.createStore)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, _disposablesJs.disposables)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: m(t)
        }, c = [
            (0, _handleIosLockingJs.handleIOSLocking)(),
            (0, _adjustScrollbarPaddingJs.adjustScrollbarPadding)(),
            (0, _preventScrollJs.preventScroll)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
a.subscribe(()=>{
    let e = a.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && a.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && a.dispatch("TEARDOWN", t);
    }
});

},{"../../utils/disposables.js":"6bVHS","../../utils/store.js":"doxAl","./adjust-scrollbar-padding.js":"lNouo","./handle-ios-locking.js":"9WIM6","./prevent-scroll.js":"hkPEJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"doxAl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", ()=>a);
function a(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lNouo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "adjustScrollbarPadding", ()=>c);
function c() {
    let o;
    return {
        before ({ doc: e }) {
            var l;
            let n = e.documentElement;
            o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after ({ doc: e, d: n }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, r = o - l;
            n.style(t, "paddingRight", `${r}px`);
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9WIM6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleIOSLocking", ()=>p);
var _platformJs = require("../../utils/platform.js");
function p() {
    if (!(0, _platformJs.isIOS)()) return {};
    let o;
    return {
        before () {
            o = window.pageYOffset;
        },
        after ({ doc: r, d: l, meta: s }) {
            function i(e) {
                return s.containers.flatMap((t)=>t()).some((t)=>t.contains(e));
            }
            l.style(r.body, "marginTop", `-${o}px`), window.scrollTo(0, 0);
            let n = null;
            l.addEventListener(r, "click", (e)=>{
                if (e.target instanceof HTMLElement) try {
                    let t = e.target.closest("a");
                    if (!t) return;
                    let { hash: c } = new URL(t.href), a = r.querySelector(c);
                    a && !i(a) && (n = a);
                } catch  {}
            }, !0), l.addEventListener(r, "touchmove", (e)=>{
                e.target instanceof HTMLElement && !i(e.target) && e.preventDefault();
            }, {
                passive: !1
            }), l.add(()=>{
                window.scrollTo(0, window.pageYOffset + o), n && n.isConnected && (n.scrollIntoView({
                    block: "nearest"
                }), n = null);
            });
        }
    };
}

},{"../../utils/platform.js":"ikixC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ikixC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAndroid", ()=>i);
parcelHelpers.export(exports, "isIOS", ()=>t);
parcelHelpers.export(exports, "isMobile", ()=>n);
function t() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function i() {
    return /Android/gi.test(window.navigator.userAgent);
}
function n() {
    return t() || i();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hkPEJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preventScroll", ()=>l);
function l() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kSJbu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInert", ()=>h);
var _useIsoMorphicEffectJs = require("./use-iso-morphic-effect.js");
let u = new Map, t = new Map;
function h(r, l = !0) {
    (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        var o;
        if (!l) return;
        let e = typeof r == "function" ? r() : r.current;
        if (!e) return;
        function a() {
            var d;
            if (!e) return;
            let i = (d = t.get(e)) != null ? d : 1;
            if (i === 1 ? t.delete(e) : t.set(e, i - 1), i !== 1) return;
            let n = u.get(e);
            n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, u.delete(e));
        }
        let f = (o = t.get(e)) != null ? o : 0;
        return t.set(e, f + 1), f !== 0 || (u.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
        }), e.setAttribute("aria-hidden", "true"), e.inert = !0), a;
    }, [
        r,
        l
    ]);
}

},{"./use-iso-morphic-effect.js":"1Aklk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6fnym":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRootContainers", ()=>p);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hiddenJs = require("../internal/hidden.js");
var _useEventJs = require("./use-event.js");
var _useOwnerJs = require("./use-owner.js");
function p({ defaultContainers: f = [], portals: o } = {}) {
    let t = (0, _react.useRef)(null), i = (0, _useOwnerJs.useOwnerDocument)(t), u = (0, _useEventJs.useEvent)(()=>{
        var r;
        let n = [];
        for (let e of f)e !== null && (e instanceof HTMLElement ? n.push(e) : "current" in e && e.current instanceof HTMLElement && n.push(e.current));
        if (o != null && o.current) for (let e of o.current)n.push(e);
        for (let e of (r = i == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? r : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(t.current) || n.some((c)=>e.contains(c)) || n.push(e));
        return n;
    });
    return {
        resolveContainers: u,
        contains: (0, _useEventJs.useEvent)((n)=>u().some((r)=>r.contains(n))),
        mainTreeNodeRef: t,
        MainTreeNode: (0, _react.useMemo)(()=>function() {
                return (0, _reactDefault.default).createElement((0, _hiddenJs.Hidden), {
                    features: (0, _hiddenJs.Features).Hidden,
                    ref: t
                });
            }, [
            t
        ])
    };
}

},{"react":"6uln9","../internal/hidden.js":"kQcB8","./use-event.js":"6LkpW","./use-owner.js":"6wF89","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"03gOy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>$e);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderJs = require("../../utils/render.js");
var _openClosedJs = require("../../internal/open-closed.js");
var _matchJs = require("../../utils/match.js");
var _useIsMountedJs = require("../../hooks/use-is-mounted.js");
var _useIsoMorphicEffectJs = require("../../hooks/use-iso-morphic-effect.js");
var _useLatestValueJs = require("../../hooks/use-latest-value.js");
var _useServerHandoffCompleteJs = require("../../hooks/use-server-handoff-complete.js");
var _useSyncRefsJs = require("../../hooks/use-sync-refs.js");
var _useTransitionJs = require("../../hooks/use-transition.js");
var _useEventJs = require("../../hooks/use-event.js");
var _useDisposablesJs = require("../../hooks/use-disposables.js");
var _classNamesJs = require("../../utils/class-names.js");
var _useFlagsJs = require("../../hooks/use-flags.js");
function x(t = "") {
    return t.split(" ").filter((n)=>n.trim().length > 1);
}
let I = (0, _react.createContext)(null);
I.displayName = "TransitionContext";
var Ce = ((r)=>(r.Visible = "visible", r.Hidden = "hidden", r))(Ce || {});
function Ee() {
    let t = (0, _react.useContext)(I);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
function be() {
    let t = (0, _react.useContext)(_);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
let _ = (0, _react.createContext)(null);
_.displayName = "NestingContext";
function M(t) {
    return "children" in t ? M(t.children) : t.current.filter(({ el: n })=>n.current !== null).filter(({ state: n })=>n === "visible").length > 0;
}
function re(t, n) {
    let r = (0, _useLatestValueJs.useLatestValue)(t), o = (0, _react.useRef)([]), N = (0, _useIsMountedJs.useIsMounted)(), H = (0, _useDisposablesJs.useDisposables)(), p = (0, _useEventJs.useEvent)((s, e = (0, _renderJs.RenderStrategy).Hidden)=>{
        let a = o.current.findIndex(({ el: i })=>i === s);
        a !== -1 && ((0, _matchJs.match)(e, {
            [(0, _renderJs.RenderStrategy).Unmount] () {
                o.current.splice(a, 1);
            },
            [(0, _renderJs.RenderStrategy).Hidden] () {
                o.current[a].state = "hidden";
            }
        }), H.microTask(()=>{
            var i;
            !M(o) && N.current && ((i = r.current) == null || i.call(r));
        }));
    }), P = (0, _useEventJs.useEvent)((s)=>{
        let e = o.current.find(({ el: a })=>a === s);
        return e ? e.state !== "visible" && (e.state = "visible") : o.current.push({
            el: s,
            state: "visible"
        }), ()=>p(s, (0, _renderJs.RenderStrategy).Unmount);
    }), h = (0, _react.useRef)([]), v = (0, _react.useRef)(Promise.resolve()), T = (0, _react.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), g = (0, _useEventJs.useEvent)((s, e, a)=>{
        h.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(([i])=>i !== s)), n == null || n.chains.current[e].push([
            s,
            new Promise((i)=>{
                h.current.push(i);
            })
        ]), n == null || n.chains.current[e].push([
            s,
            new Promise((i)=>{
                Promise.all(T.current[e].map(([l, R])=>R)).then(()=>i());
            })
        ]), e === "enter" ? v.current = v.current.then(()=>n == null ? void 0 : n.wait.current).then(()=>a(e)) : a(e);
    }), f = (0, _useEventJs.useEvent)((s, e, a)=>{
        Promise.all(T.current[e].splice(0).map(([i, l])=>l)).then(()=>{
            var i;
            (i = h.current.shift()) == null || i();
        }).then(()=>a(e));
    });
    return (0, _react.useMemo)(()=>({
            children: o,
            register: P,
            unregister: p,
            onStart: g,
            onStop: f,
            wait: v,
            chains: T
        }), [
        P,
        p,
        o,
        g,
        f,
        T,
        v
    ]);
}
function Se() {}
let xe = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function ie(t) {
    var r;
    let n = {};
    for (let o of xe)n[o] = (r = t[o]) != null ? r : Se;
    return n;
}
function Pe(t) {
    let n = (0, _react.useRef)(ie(t));
    return (0, _react.useEffect)(()=>{
        n.current = ie(t);
    }, [
        t
    ]), n;
}
let Re = "div", oe = (0, _renderJs.Features).RenderStrategy;
function ye(t, n) {
    let { beforeEnter: r, afterEnter: o, beforeLeave: N, afterLeave: H, enter: p, enterFrom: P, enterTo: h, entered: v, leave: T, leaveFrom: g, leaveTo: f, ...s } = t, e = (0, _react.useRef)(null), a = (0, _useSyncRefsJs.useSyncRefs)(e, n), i = s.unmount ? (0, _renderJs.RenderStrategy).Unmount : (0, _renderJs.RenderStrategy).Hidden, { show: l, appear: R, initial: d } = Ee(), [u, U] = (0, _react.useState)(l ? "visible" : "hidden"), K = be(), { register: L, unregister: w } = K, j = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>L(e), [
        L,
        e
    ]), (0, _react.useEffect)(()=>{
        if (i === (0, _renderJs.RenderStrategy).Hidden && e.current) {
            if (l && u !== "visible") {
                U("visible");
                return;
            }
            return (0, _matchJs.match)(u, {
                ["hidden"]: ()=>w(e),
                ["visible"]: ()=>L(e)
            });
        }
    }, [
        u,
        e,
        L,
        w,
        l,
        i
    ]);
    let k = (0, _useLatestValueJs.useLatestValue)({
        enter: x(p),
        enterFrom: x(P),
        enterTo: x(h),
        entered: x(v),
        leave: x(T),
        leaveFrom: x(g),
        leaveTo: x(f)
    }), O = Pe({
        beforeEnter: r,
        afterEnter: o,
        beforeLeave: N,
        afterLeave: H
    }), G = (0, _useServerHandoffCompleteJs.useServerHandoffComplete)();
    (0, _react.useEffect)(()=>{
        if (G && u === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        e,
        u,
        G
    ]);
    let B = d && !R, ae = (()=>!G || B || j.current === l ? "idle" : l ? "enter" : "leave")(), D = (0, _useFlagsJs.useFlags)(0), le = (0, _useEventJs.useEvent)((C)=>(0, _matchJs.match)(C, {
            enter: ()=>{
                D.addFlag((0, _openClosedJs.State).Opening), O.current.beforeEnter();
            },
            leave: ()=>{
                D.addFlag((0, _openClosedJs.State).Closing), O.current.beforeLeave();
            },
            idle: ()=>{}
        })), ue = (0, _useEventJs.useEvent)((C)=>(0, _matchJs.match)(C, {
            enter: ()=>{
                D.removeFlag((0, _openClosedJs.State).Opening), O.current.afterEnter();
            },
            leave: ()=>{
                D.removeFlag((0, _openClosedJs.State).Closing), O.current.afterLeave();
            },
            idle: ()=>{}
        })), V = re(()=>{
        U("hidden"), w(e);
    }, K);
    (0, _useTransitionJs.useTransition)({
        container: e,
        classes: k,
        direction: ae,
        onStart: (0, _useLatestValueJs.useLatestValue)((C)=>{
            V.onStart(e, C, le);
        }),
        onStop: (0, _useLatestValueJs.useLatestValue)((C)=>{
            V.onStop(e, C, ue), C === "leave" && !M(V) && (U("hidden"), w(e));
        })
    }), (0, _react.useEffect)(()=>{
        B && (i === (0, _renderJs.RenderStrategy).Hidden ? j.current = null : j.current = l);
    }, [
        l,
        B,
        u
    ]);
    let J = s, Te = {
        ref: a
    };
    return R && l && d && (J = {
        ...J,
        className: (0, _classNamesJs.classNames)(s.className, ...k.current.enter, ...k.current.enterFrom)
    }), (0, _reactDefault.default).createElement(_.Provider, {
        value: V
    }, (0, _reactDefault.default).createElement((0, _openClosedJs.OpenClosedProvider), {
        value: (0, _matchJs.match)(u, {
            ["visible"]: (0, _openClosedJs.State).Open,
            ["hidden"]: (0, _openClosedJs.State).Closed
        }) | D.flags
    }, (0, _renderJs.render)({
        ourProps: Te,
        theirProps: J,
        defaultTag: Re,
        features: oe,
        visible: u === "visible",
        name: "Transition.Child"
    })));
}
function Ne(t, n) {
    let { show: r, appear: o = !1, unmount: N, ...H } = t, p = (0, _react.useRef)(null), P = (0, _useSyncRefsJs.useSyncRefs)(p, n);
    (0, _useServerHandoffCompleteJs.useServerHandoffComplete)();
    let h = (0, _openClosedJs.useOpenClosed)();
    if (r === void 0 && h !== null && (r = (h & (0, _openClosedJs.State).Open) === (0, _openClosedJs.State).Open), ![
        !0,
        !1
    ].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [v, T] = (0, _react.useState)(r ? "visible" : "hidden"), g = re(()=>{
        T("hidden");
    }), [f, s] = (0, _react.useState)(!0), e = (0, _react.useRef)([
        r
    ]);
    (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        f !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), s(!1));
    }, [
        e,
        r
    ]);
    let a = (0, _react.useMemo)(()=>({
            show: r,
            appear: o,
            initial: f
        }), [
        r,
        o,
        f
    ]);
    (0, _react.useEffect)(()=>{
        if (r) T("visible");
        else if (!M(g)) T("hidden");
        else {
            let d = p.current;
            if (!d) return;
            let u = d.getBoundingClientRect();
            u.x === 0 && u.y === 0 && u.width === 0 && u.height === 0 && T("hidden");
        }
    }, [
        r,
        g
    ]);
    let i = {
        unmount: N
    }, l = (0, _useEventJs.useEvent)(()=>{
        var d;
        f && s(!1), (d = t.beforeEnter) == null || d.call(t);
    }), R = (0, _useEventJs.useEvent)(()=>{
        var d;
        f && s(!1), (d = t.beforeLeave) == null || d.call(t);
    });
    return (0, _reactDefault.default).createElement(_.Provider, {
        value: g
    }, (0, _reactDefault.default).createElement(I.Provider, {
        value: a
    }, (0, _renderJs.render)({
        ourProps: {
            ...i,
            as: (0, _react.Fragment),
            children: (0, _reactDefault.default).createElement(se, {
                ref: P,
                ...i,
                ...H,
                beforeEnter: l,
                beforeLeave: R
            })
        },
        theirProps: {},
        defaultTag: (0, _react.Fragment),
        features: oe,
        visible: v === "visible",
        name: "Transition"
    })));
}
function He(t, n) {
    let r = (0, _react.useContext)(I) !== null, o = (0, _openClosedJs.useOpenClosed)() !== null;
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, !r && o ? (0, _reactDefault.default).createElement(z, {
        ref: n,
        ...t
    }) : (0, _reactDefault.default).createElement(se, {
        ref: n,
        ...t
    }));
}
let z = (0, _renderJs.forwardRefWithAs)(Ne), se = (0, _renderJs.forwardRefWithAs)(ye), De = (0, _renderJs.forwardRefWithAs)(He), $e = Object.assign(z, {
    Child: De,
    Root: z
});

},{"react":"6uln9","../../utils/render.js":"hFxMl","../../internal/open-closed.js":"UnZmT","../../utils/match.js":"AWHzT","../../hooks/use-is-mounted.js":"4Sa1d","../../hooks/use-iso-morphic-effect.js":"1Aklk","../../hooks/use-latest-value.js":"f2MN3","../../hooks/use-server-handoff-complete.js":"bJA23","../../hooks/use-sync-refs.js":"61fW1","../../hooks/use-transition.js":"lmjjm","../../hooks/use-event.js":"6LkpW","../../hooks/use-disposables.js":"kS4kq","../../utils/class-names.js":"9OIM4","../../hooks/use-flags.js":"6rKpx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lmjjm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTransition", ()=>D);
var _transitionJs = require("../components/transitions/utils/transition.js");
var _disposablesJs = require("../utils/disposables.js");
var _useDisposablesJs = require("./use-disposables.js");
var _useIsMountedJs = require("./use-is-mounted.js");
var _useIsoMorphicEffectJs = require("./use-iso-morphic-effect.js");
var _useLatestValueJs = require("./use-latest-value.js");
function D({ container: i, direction: t, classes: o, onStart: s, onStop: u }) {
    let a = (0, _useIsMountedJs.useIsMounted)(), c = (0, _useDisposablesJs.useDisposables)(), r = (0, _useLatestValueJs.useLatestValue)(t);
    (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        let e = (0, _disposablesJs.disposables)();
        c.add(e.dispose);
        let n = i.current;
        if (n && r.current !== "idle" && a.current) return e.dispose(), s.current(r.current), e.add((0, _transitionJs.transition)(n, o.current, r.current === "enter", ()=>{
            e.dispose(), u.current(r.current);
        })), e.dispose;
    }, [
        t
    ]);
}

},{"../components/transitions/utils/transition.js":"hsUmI","../utils/disposables.js":"6bVHS","./use-disposables.js":"kS4kq","./use-is-mounted.js":"4Sa1d","./use-iso-morphic-effect.js":"1Aklk","./use-latest-value.js":"f2MN3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hsUmI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transition", ()=>y);
var _onceJs = require("../../../utils/once.js");
var _disposablesJs = require("../../../utils/disposables.js");
var _matchJs = require("../../../utils/match.js");
function d(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function v(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
function F(t, e) {
    let n = (0, _disposablesJs.disposables)();
    if (!t) return n.dispose;
    let { transitionDuration: m, transitionDelay: o } = getComputedStyle(t), [u, p] = [
        m,
        o
    ].map((a)=>{
        let [r = 0] = a.split(",").filter(Boolean).map((i)=>i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3).sort((i, f)=>f - i);
        return r;
    }), l = u + p;
    if (l !== 0) {
        n.group((r)=>{
            r.setTimeout(()=>{
                e(), r.dispose();
            }, l), r.addEventListener(t, "transitionrun", (i)=>{
                i.target === i.currentTarget && r.dispose();
            });
        });
        let a = n.addEventListener(t, "transitionend", (r)=>{
            r.target === r.currentTarget && (e(), a());
        });
    } else e();
    return n.add(()=>e()), n.dispose;
}
function y(t, e, n, m) {
    let o = n ? "enter" : "leave", u = (0, _disposablesJs.disposables)(), p = m !== void 0 ? (0, _onceJs.once)(m) : ()=>{};
    o === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
    let l = (0, _matchJs.match)(o, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), a = (0, _matchJs.match)(o, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, _matchJs.match)(o, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return v(t, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), d(t, ...l, ...r), u.nextFrame(()=>{
        v(t, ...r), d(t, ...a), F(t, ()=>(v(t, ...l), d(t, ...e.entered), p()));
    }), u.dispose;
}

},{"../../../utils/once.js":"erIss","../../../utils/disposables.js":"6bVHS","../../../utils/match.js":"AWHzT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"erIss":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "once", ()=>l);
function l(r) {
    let e = {
        called: !1
    };
    return (...t)=>{
        if (!e.called) return e.called = !0, r(...t);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6rKpx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFlags", ()=>c);
var _react = require("react");
var _useIsMountedJs = require("./use-is-mounted.js");
function c(a = 0) {
    let [l, r] = (0, _react.useState)(a), t = (0, _useIsMountedJs.useIsMounted)(), o = (0, _react.useCallback)((e)=>{
        t.current && r((u)=>u | e);
    }, [
        l,
        t
    ]), m = (0, _react.useCallback)((e)=>Boolean(l & e), [
        l
    ]), s = (0, _react.useCallback)((e)=>{
        t.current && r((u)=>u & ~e);
    }, [
        r,
        t
    ]), g = (0, _react.useCallback)((e)=>{
        t.current && r((u)=>u ^ e);
    }, [
        r
    ]);
    return {
        flags: l,
        addFlag: o,
        hasFlag: m,
        removeFlag: s,
        toggleFlag: g
    };
}

},{"react":"6uln9","./use-is-mounted.js":"4Sa1d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7gz5g":[function() {},{}],"hasfJ":[function(require,module,exports) {
var global = arguments[3];
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(this, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof global && global.global === global ? global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

},{}]},["5Tqlz"], "5Tqlz", "parcelRequireb8e7")

//# sourceMappingURL=index.55f57181.js.map
